import linkedinIcon from "@/assets/icons/icon-linkedin-logo.png"
import pinterestIcon from "@/assets/icons/icon-pinterest.png"
import instaIcon from "@/assets/icons/icon-platforms-instagram.png"
import tiktokIcon from "@/assets/icons/icon-tiktok.png"
import twitterIcon from "@/assets/icons/icon-twitter.png"
import youtubeIcon from "@/assets/icons/icon-youtube.png"
import ravenLogo from "@/assets/icons/raven.png"
import scheduled from "@/assets/icons/scheduled.png"
import success from "@/assets/icons/success.png"
import IconNames from "@/types/icons"
import { Stack, SvgIcon, SxProps } from "@mui/material"

const Icon = ({
    name,
    className,
    sx,
    size,
    fill,
    color = "currentcolor",
}: {
    name: IconNames
    color?: string
    size?: number
    fill?: string
    sx?: SxProps
    className?: string
}) => {
    const icons = {
        arrowCollapse: (
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.4333 17.4996L6.6 11.4996M6.6 11.4996L12.4333 5.49961M6.6 11.4996L21 11.4996M1.8 1.89961L1.8 21.0996"
                    stroke="#808CA9"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        dashboard: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        messaging: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="20"
                height="19"
                viewBox="0 0 20 19"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.33073 11.9993L5.76802 14.5941C5.41055 14.956 5.23182 15.137 5.07819 15.1498C4.94491 15.1608 4.81441 15.1073 4.72736 15.0057C4.62703 14.8887 4.62703 14.6343 4.62703 14.1256V12.8257C4.62703 12.3693 4.25329 12.0391 3.80173 11.973V11.973C2.70885 11.8129 1.85054 10.9546 1.69046 9.86168C1.66406 9.68148 1.66406 9.46645 1.66406 9.03638V5.16602C1.66406 3.76588 1.66406 3.06582 1.93655 2.53104C2.17623 2.06063 2.55868 1.67818 3.02909 1.4385C3.56387 1.16602 4.26393 1.16602 5.66406 1.16602H11.8307C13.2309 1.16602 13.9309 1.16602 14.4657 1.4385C14.9361 1.67818 15.3186 2.06063 15.5582 2.53104C15.8307 3.06582 15.8307 3.76588 15.8307 5.16602V8.66602M15.8307 17.8327L14.0171 16.5717C13.7621 16.3945 13.6346 16.3059 13.4959 16.243C13.3728 16.1873 13.2433 16.1467 13.1104 16.1222C12.9606 16.0946 12.8053 16.0946 12.4948 16.0946H10.9974C10.064 16.0946 9.59727 16.0946 9.24075 15.9129C8.92714 15.7531 8.67217 15.4982 8.51239 15.1846C8.33073 14.8281 8.33073 14.3613 8.33073 13.4279V11.3327C8.33073 10.3993 8.33073 9.93255 8.51239 9.57603C8.67217 9.26243 8.92714 9.00746 9.24075 8.84767C9.59727 8.66602 10.064 8.66602 10.9974 8.66602H15.6641C16.5975 8.66602 17.0642 8.66602 17.4207 8.84767C17.7343 9.00746 17.9893 9.26243 18.1491 9.57603C18.3307 9.93255 18.3307 10.3993 18.3307 11.3327V13.5946C18.3307 14.3712 18.3307 14.7594 18.2039 15.0657C18.0347 15.4741 17.7102 15.7986 17.3019 15.9677C16.9956 16.0946 16.6073 16.0946 15.8307 16.0946V17.8327Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        messageText: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M7 8.5H12M7 12H15M9.68375 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V20.3355C3 20.8684 3 21.1348 3.10923 21.2716C3.20422 21.3906 3.34827 21.4599 3.50054 21.4597C3.67563 21.4595 3.88367 21.2931 4.29976 20.9602L6.68521 19.0518C7.17252 18.662 7.41617 18.4671 7.68749 18.3285C7.9282 18.2055 8.18443 18.1156 8.44921 18.0613C8.74767 18 9.0597 18 9.68375 18Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        setting: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="18"
                height="19"
                viewBox="0 0 18 19"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.68239 15.6419L7.16943 16.7373C7.31421 17.0634 7.55049 17.3404 7.84962 17.5349C8.14874 17.7293 8.49785 17.8327 8.85461 17.8327C9.21138 17.8327 9.56049 17.7293 9.85961 17.5349C10.1587 17.3404 10.395 17.0634 10.5398 16.7373L11.0268 15.6419C11.2002 15.2533 11.4918 14.9292 11.8602 14.716C12.2308 14.5022 12.6596 14.4111 13.0852 14.4558L14.2768 14.5827C14.6316 14.6202 14.9896 14.554 15.3074 14.3921C15.6253 14.2302 15.8893 13.9796 16.0676 13.6706C16.2461 13.3619 16.3311 13.0079 16.3124 12.6518C16.2936 12.2956 16.1719 11.9525 15.962 11.6642L15.2565 10.6947C15.0052 10.347 14.871 9.92836 14.8731 9.49935C14.8731 9.07151 15.0086 8.65464 15.2602 8.30861L15.9657 7.33916C16.1756 7.05081 16.2973 6.70774 16.3161 6.35158C16.3348 5.99541 16.2498 5.64147 16.0713 5.33268C15.893 5.02371 15.629 4.77309 15.3111 4.61121C14.9933 4.44932 14.6353 4.38312 14.2805 4.42065L13.0889 4.5475C12.6633 4.59219 12.2345 4.50112 11.8639 4.28731C11.4948 4.07289 11.2031 3.74715 11.0305 3.35676L10.5398 2.26139C10.395 1.93532 10.1587 1.65828 9.85961 1.46385C9.56049 1.26942 9.21138 1.16596 8.85461 1.16602C8.49785 1.16596 8.14874 1.26942 7.84962 1.46385C7.55049 1.65828 7.31421 1.93532 7.16943 2.26139L6.68239 3.35676C6.50983 3.74715 6.21812 4.07289 5.84906 4.28731C5.4784 4.50112 5.04962 4.59219 4.62406 4.5475L3.42869 4.42065C3.07396 4.38312 2.71597 4.44932 2.39812 4.61121C2.08026 4.77309 1.8162 5.02371 1.63795 5.33268C1.45946 5.64147 1.37443 5.99541 1.39317 6.35158C1.41191 6.70774 1.53361 7.05081 1.7435 7.33916L2.44906 8.30861C2.70068 8.65464 2.83617 9.07151 2.8361 9.49935C2.83617 9.92719 2.70068 10.3441 2.44906 10.6901L1.7435 11.6595C1.53361 11.9479 1.41191 12.291 1.39317 12.6471C1.37443 13.0033 1.45946 13.3572 1.63795 13.666C1.81638 13.9748 2.08047 14.2253 2.39828 14.3872C2.71609 14.549 3.07399 14.6153 3.42869 14.5781L4.62036 14.4512C5.04591 14.4065 5.4747 14.4976 5.84536 14.7114C6.2158 14.9252 6.50886 15.251 6.68239 15.6419Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.85313 11.9993C10.2338 11.9993 11.3531 10.8801 11.3531 9.49935C11.3531 8.11864 10.2338 6.99935 8.85313 6.99935C7.47241 6.99935 6.35313 8.11864 6.35313 9.49935C6.35313 10.8801 7.47241 11.9993 8.85313 11.9993Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        send: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
            >
                <path
                    d="M11.0995 13.5002L21.5995 3.00017M11.2271 13.8282L13.8552 20.5862C14.0867 21.1816 14.2025 21.4793 14.3693 21.5662C14.5139 21.6415 14.6862 21.6416 14.8308 21.5664C14.9978 21.4797 15.1139 21.1822 15.3461 20.5871L21.9364 3.69937C22.1461 3.16219 22.2509 2.8936 22.1935 2.72197C22.1437 2.57292 22.0268 2.45596 21.8777 2.40616C21.7061 2.34883 21.4375 2.45364 20.9003 2.66327L4.01258 9.25361C3.41751 9.48584 3.11997 9.60195 3.03326 9.76886C2.9581 9.91354 2.9582 10.0858 3.03353 10.2304C3.12044 10.3972 3.41811 10.513 4.01346 10.7445L10.7715 13.3726C10.8923 13.4196 10.9527 13.4431 11.0036 13.4794C11.0487 13.5115 11.0882 13.551 11.1203 13.5961C11.1566 13.647 11.1801 13.7074 11.2271 13.8282Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        yellowStar: (
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.56 1.31391C10.7666 0.895364 11.3634 0.895364 11.57 1.31391L14.244 6.73203C14.326 6.89824 14.4846 7.01344 14.668 7.04009L20.6473 7.90893C21.1092 7.97604 21.2936 8.54367 20.9594 8.86946L16.6327 13.0869C16.5 13.2163 16.4394 13.4027 16.4708 13.5853L17.4921 19.5404C17.571 20.0004 17.0882 20.3513 16.6751 20.1341L11.3271 17.3224C11.163 17.2362 10.967 17.2362 10.803 17.3224L5.45496 20.1341C5.04183 20.3513 4.55898 20.0004 4.63788 19.5404L5.65926 13.5853C5.69059 13.4027 5.63003 13.2163 5.4973 13.0869L1.17067 8.86946C0.836446 8.54367 1.02088 7.97604 1.48277 7.90893L7.46203 7.04009C7.64544 7.01344 7.804 6.89824 7.88603 6.73203L10.56 1.31391Z"
                    stroke="#FFC431"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        greyStar: (
            <SvgIcon
                width="23"
                height="22"
                viewBox="0 0 23 22"
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.56 1.31391C10.7666 0.895364 11.3634 0.895364 11.57 1.31391L14.244 6.73203C14.326 6.89824 14.4846 7.01344 14.668 7.04009L20.6473 7.90893C21.1092 7.97604 21.2936 8.54367 20.9594 8.86946L16.6327 13.0869C16.5 13.2163 16.4394 13.4027 16.4708 13.5853L17.4921 19.5404C17.571 20.0004 17.0882 20.3513 16.6751 20.1341L11.3271 17.3224C11.163 17.2362 10.967 17.2362 10.803 17.3224L5.45496 20.1341C5.04183 20.3513 4.55898 20.0004 4.63788 19.5404L5.65926 13.5853C5.69059 13.4027 5.63003 13.2163 5.4973 13.0869L1.17067 8.86946C0.836446 8.54367 1.02088 7.97604 1.48277 7.90893L7.46203 7.04009C7.64544 7.01344 7.804 6.89824 7.88603 6.73203L10.56 1.31391Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        doubleStar: (
            <SvgIcon
                sx={{
                    fill: "none",
                    width: size || 24,
                    height: size || 24,
                    ...sx,
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        share: (
            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.49981 7.35902L11.0998 1L11.0998 4.6C19.5 6.4 19.5 14.8 19.5 14.8C19.5 14.8 15.9 10 11.0998 10.6L11.0998 14.32L1.49981 7.35902Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        google: (
            <SvgIcon
                sx={{
                    fill: "none",
                    width: size || 24,
                    height: size || 24,
                    ...sx,
                }}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.24 12.2424C22.24 11.486 22.1721 10.7587 22.0461 10.0605H12V14.1866H17.7406C17.4933 15.5199 16.7418 16.6496 15.6121 17.406V20.0824H19.0594C21.0764 18.2254 22.24 15.4909 22.24 12.2424Z"
                    fill="#4285F4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.997 22.6673C14.877 22.6673 17.2915 21.7122 19.0563 20.083L15.6091 17.4067C14.654 18.0467 13.4322 18.4249 11.997 18.4249C9.21879 18.4249 6.86727 16.5485 6.02848 14.0273H2.46484V16.791C4.22 20.2769 7.82727 22.6673 11.997 22.6673Z"
                    fill="#34A853"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.03021 14.0279C5.81688 13.3879 5.69567 12.7043 5.69567 12.0012C5.69567 11.2982 5.81688 10.6146 6.03021 9.97457V7.21094H2.46658C1.74415 8.65094 1.33203 10.28 1.33203 12.0012C1.33203 13.7224 1.74415 15.3515 2.46658 16.7915L6.03021 14.0279Z"
                    fill="#FBBC05"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.997 5.57641C13.563 5.57641 14.9691 6.11459 16.0745 7.17155L19.134 4.11216C17.2866 2.39095 14.8722 1.33398 11.997 1.33398C7.82727 1.33398 4.22 3.72429 2.46484 7.21034L6.02848 9.97398C6.86727 7.45277 9.21879 5.57641 11.997 5.57641Z"
                    fill="#EA4335"
                />
            </SvgIcon>
        ),
        globe: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22M2.50002 9H21.5M2.5 15H21.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        call: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="20"
                height="19"
                viewBox="0 0 20 19"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.5818 7.96602L11.3385 4.7228M11.3385 4.7228L14.2029 1.85547M11.3385 4.7228L18.7078 4.7228M16.6593 15.7055C16.6593 15.7055 15.666 16.6811 15.4226 16.9671C15.0261 17.3902 14.5589 17.59 13.9464 17.59C13.8875 17.59 13.8247 17.59 13.7658 17.5861C12.5998 17.5117 11.5162 17.0572 10.7035 16.6693C8.48141 15.5958 6.53018 14.0717 4.90874 12.1401C3.56996 10.5298 2.67483 9.04097 2.082 7.44243C1.71688 6.46684 1.5834 5.70675 1.64229 4.98976C1.68155 4.53135 1.85822 4.15131 2.18408 3.82611L3.52285 2.49008C3.71523 2.30985 3.91938 2.2119 4.11961 2.2119C4.36695 2.2119 4.56717 2.36078 4.69281 2.48616C4.69673 2.49008 4.70066 2.494 4.70458 2.49791C4.94407 2.72124 5.17178 2.9524 5.41127 3.19923C5.53297 3.32461 5.65861 3.44999 5.78424 3.57928L6.85604 4.64889C7.2722 5.0642 7.2722 5.44817 6.85604 5.86347C6.74219 5.97709 6.63226 6.09072 6.5184 6.20042C6.18862 6.53737 6.44768 6.27883 6.10612 6.58443C6.09827 6.59227 6.09042 6.59619 6.08649 6.60402C5.74885 6.94097 5.81167 7.27008 5.88234 7.49341C5.88626 7.50516 5.89019 7.51692 5.89412 7.52867C6.17286 8.20257 6.56546 8.83728 7.16222 9.59345L7.16615 9.59737C8.24973 10.9295 9.3922 11.9678 10.6524 12.7631C10.8134 12.865 10.9783 12.9473 11.1353 13.0256C11.2767 13.0961 11.4102 13.1627 11.524 13.2333C11.5397 13.2411 11.5554 13.2529 11.5711 13.2607C11.7046 13.3273 11.8303 13.3587 11.9598 13.3587C12.2857 13.3587 12.4898 13.1549 12.5566 13.0883L13.3261 12.3203C13.4596 12.1871 13.6716 12.0265 13.9189 12.0265C14.1624 12.0265 14.3626 12.1793 14.4843 12.3125C14.4882 12.3164 14.4882 12.3164 14.4921 12.3203L16.6554 14.4791C17.0598 14.8788 16.6593 15.7055 16.6593 15.7055Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        info: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="22"
                height="22"
                viewBox="0 0 22 22"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.2875 11.0004L11.2875 15.8004M11.2875 7.44258V7.40039M1.6875 11.0004C1.6875 5.69846 5.98557 1.40039 11.2875 1.40039C16.5894 1.40039 20.8875 5.69846 20.8875 11.0004C20.8875 16.3023 16.5894 20.6004 11.2875 20.6004C5.98557 20.6004 1.6875 16.3023 1.6875 11.0004Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        profile: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                className={className}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        campaign: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.84154 14.0316L12.8307 3.04863C13.0993 2.62661 13.7525 2.81684 13.7525 3.31706V11.1C13.7525 11.1553 13.7973 11.2 13.8525 11.2H18.7922C19.1967 11.2 19.4338 11.6554 19.2018 11.9868L12.2622 21.9006C11.9818 22.3011 11.3525 22.1027 11.3525 21.6139V14.9C11.3525 14.8448 11.3078 14.8 11.2525 14.8H6.26338C5.86883 14.8 5.62972 14.3645 5.84154 14.0316Z"
                    stroke="#808CA9"
                    strokeWidth="2"
                />
            </SvgIcon>
        ),
        analytics: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.00098 20.9V8.1M9.40098 20.9V13.4333M15.801 20.9V3.5M22.201 20.9V8.1"
                    stroke="#808CA9"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        qrCode: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.5 6.5H6.51M17.5 6.5H17.51M6.5 17.5H6.51M13 13H13.01M17.5 17.5H17.51M17 21H21V17M14 16.5V21M21 14H16.5M15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10ZM4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        notification: (
            <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.11877 19.5626L0.321087 18.9596H0.321087L1.11877 19.5626ZM2.42712 15.8352L1.42712 15.823V15.8352H2.42712ZM2.45458 13.5816L3.45458 13.5938V13.5816H2.45458ZM18.8882 19.5807L19.6978 18.9938L19.6978 18.9938L18.8882 19.5807ZM17.6291 15.8352L16.6291 15.8224V15.8352H17.6291ZM17.6566 13.6933L18.6566 13.7061V13.6933H17.6566ZM1.91645 20.1657C2.67079 19.168 3.42712 17.6697 3.42712 15.8352H1.42712C1.42712 17.1113 0.898267 18.1961 0.321087 18.9596L1.91645 20.1657ZM3.42705 15.8474L3.45451 13.5938L1.45466 13.5694L1.4272 15.823L3.42705 15.8474ZM19.6978 18.9938C19.1452 18.2314 18.6291 17.1341 18.6291 15.8352H16.6291C16.6291 17.6683 17.3539 19.1681 18.0786 20.1677L19.6978 18.9938ZM18.629 15.848L18.6565 13.7061L16.6566 13.6805L16.6292 15.8224L18.629 15.848ZM18.6566 13.6933C18.6566 8.89671 14.7854 5.0002 10 5.0002V7.0002C13.6718 7.0002 16.6566 9.9923 16.6566 13.6933H18.6566ZM18.43 21.6252C19.1898 21.6252 19.6667 21.0896 19.859 20.6357C20.0507 20.1832 20.0897 19.5343 19.6978 18.9938L18.0786 20.1677C17.9625 20.0076 18.0067 19.8809 18.0174 19.8555C18.0288 19.8287 18.1387 19.6252 18.43 19.6252V21.6252ZM3.45458 13.5816C3.45458 9.9423 6.38955 7.0002 10 7.0002V5.0002C5.27602 5.0002 1.45458 8.84671 1.45458 13.5816H3.45458ZM1.57109 19.6252C1.70569 19.6252 1.81669 19.677 1.88642 19.7331C1.94916 19.7835 1.97456 19.8321 1.98443 19.8562C1.99471 19.8812 2.00238 19.9134 1.99933 19.9576C1.99613 20.004 1.97867 20.0834 1.91645 20.1657L0.321087 18.9596C-0.088161 19.5009 -0.0528362 20.1603 0.134505 20.6163C0.32215 21.073 0.798687 21.6252 1.57109 21.6252V19.6252ZM18.43 19.6252H1.57109V21.6252H18.43V19.6252ZM12.6 20.6252C12.6 21.8771 11.4977 23.0002 10 23.0002V25.0002C12.4787 25.0002 14.6 23.1012 14.6 20.6252H12.6ZM10 23.0002C8.50229 23.0002 7.4 21.8771 7.4 20.6252H5.4C5.4 23.1012 7.52126 25.0002 10 25.0002V23.0002ZM11.4 3.6002C11.4 4.37339 10.7732 5.0002 10 5.0002V7.0002C11.8778 7.0002 13.4 5.47796 13.4 3.6002H11.4ZM10 5.0002C9.2268 5.0002 8.6 4.37339 8.6 3.6002H6.6C6.6 5.47796 8.12223 7.0002 10 7.0002V5.0002ZM8.6 3.6002C8.6 2.827 9.2268 2.2002 10 2.2002V0.200195C8.12223 0.200195 6.6 1.72243 6.6 3.6002H8.6ZM10 2.2002C10.7732 2.2002 11.4 2.827 11.4 3.6002H13.4C13.4 1.72243 11.8778 0.200195 10 0.200195V2.2002Z"
                    fill="currentColor"
                />
            </svg>
        ),
        delete: (
            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L10 12M10 6L16 12M1.72 9.96L6.04 15.72C6.392 16.1893 6.568 16.424 6.79105 16.5932C6.9886 16.7432 7.21232 16.855 7.45077 16.9231C7.72 17 8.01334 17 8.6 17H16.2C17.8802 17 18.7202 17 19.362 16.673C19.9265 16.3854 20.3854 15.9265 20.673 15.362C21 14.7202 21 13.8802 21 12.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1H8.6C8.01334 1 7.72 1 7.45077 1.07689C7.21232 1.14499 6.9886 1.25685 6.79105 1.40675C6.568 1.576 6.392 1.81067 6.04 2.28L1.72 8.04C1.46181 8.38426 1.33271 8.55639 1.28294 8.74543C1.23902 8.9123 1.23902 9.0877 1.28294 9.25457C1.33271 9.44361 1.46181 9.61574 1.72 9.96Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        eye: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                className={className}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        mouse: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9V6M12 22C8.13401 22 5 18.866 5 15V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15C19 18.866 15.866 22 12 22Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        call1: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.0497 6C15.0264 6.19057 15.924 6.66826 16.6277 7.37194C17.3314 8.07561 17.8091 8.97326 17.9997 9.95M14.0497 2C16.0789 2.22544 17.9713 3.13417 19.4159 4.57701C20.8606 6.01984 21.7717 7.91101 21.9997 9.94M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        lightBulb: (
            <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.5 21H10.5M6 9H10M8 9L8 15M11 14.3264C13.3649 13.2029 15 10.7924 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 10.7924 2.63505 13.2029 5 14.3264V15C5 15.9319 5 16.3978 5.15224 16.7654C5.35523 17.2554 5.74458 17.6448 6.23463 17.8478C6.60218 18 7.06812 18 8 18C8.93188 18 9.39782 18 9.76537 17.8478C10.2554 17.6448 10.6448 17.2554 10.8478 16.7654C11 16.3978 11 15.9319 11 15V14.3264Z"
                    stroke="#FFC431"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        chevronLeft: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 18L9 12L15 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        chevronRight: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9 18L15 12L9 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        chevronUp: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M18 15L12 9L6 15"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        chevronDown: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M6 9L12 15L18 9"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        plus: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 5V19M5 12H19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        mobileMenu: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M3 12H15M3 6H21M3 18H21"
                    stroke="#00041F"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        mobileLogo: (
            <svg width="162" height="46" viewBox="0 0 162 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_815_40179)">
                    <path
                        d="M4.27734 0H18.0073C30.4861 0 36.688 9.17144 36.688 18.9643C36.688 27.5357 29.8765 37.9178 19.4187 37.9178H4.27734L7.19653 30.2464H18.3494C22.6266 30.2464 28.5399 26.5714 28.5399 18.9643C28.5769 16.1602 27.5418 13.4482 25.647 11.3843C23.7523 9.32043 21.1412 8.06099 18.3494 7.86425H7.74189L4.27734 0Z"
                        fill="url(#paint0_linear_815_40179)"
                    />
                    <path opacity="0.35" d="M4.25586 0L13.1418 7.86429H6.83289L4.25586 0Z" fill="currentColor" />
                    <path
                        opacity="0.35"
                        d="M4.25586 37.9071L13.1418 30.2464L6.27685 29.9464L4.25586 37.9071Z"
                        fill="currentColor"
                    />
                    <path
                        d="M4.25584 37.9071L15.4301 19.05L4.25584 0L0 8.16429L6.46931 18.9536L0 30.45L4.25584 37.9071Z"
                        fill="currentColor"
                    />
                    <path
                        d="M44.7923 9.34953C43.7718 9.34953 42.9168 9.03234 42.2273 8.39798C41.5653 7.73603 41.2344 6.92239 41.2344 5.95705C41.2344 4.99171 41.5653 4.19186 42.2273 3.55749C42.9168 2.89555 43.7718 2.56458 44.7923 2.56458C45.8128 2.56458 46.6541 2.89555 47.316 3.55749C48.0055 4.19186 48.3503 4.99171 48.3503 5.95705C48.3503 6.92239 48.0055 7.73603 47.316 8.39798C46.6541 9.03234 45.8128 9.34953 44.7923 9.34953ZM47.647 12.0801V35H41.8549V12.0801H47.647Z"
                        fill="currentColor"
                    />
                    <path d="M59.1616 4.38493V35H53.3695V4.38493H59.1616Z" fill="currentColor" />
                    <path
                        d="M86.8111 12.0801L72.6206 45.8393H66.4562L71.4208 34.4207L62.2363 12.0801H68.7317L74.6478 28.0909L80.6467 12.0801H86.8111Z"
                        fill="currentColor"
                    />
                    <path
                        d="M95.7254 15.3898C96.4701 14.3417 97.4906 13.4729 98.7869 12.7834C100.111 12.0663 101.614 11.7077 103.296 11.7077C105.255 11.7077 107.02 12.1904 108.592 13.1557C110.192 14.1211 111.447 15.5001 112.357 17.2929C113.295 19.0581 113.763 21.1129 113.763 23.4573C113.763 25.8017 113.295 27.884 112.357 29.7044C111.447 31.4972 110.192 32.89 108.592 33.8829C107.02 34.8758 105.255 35.3723 103.296 35.3723C101.614 35.3723 100.125 35.0275 98.8282 34.338C97.5595 33.6485 96.5252 32.7797 95.7254 31.7316V45.9221H89.9333V12.0801H95.7254V15.3898ZM107.847 23.4573C107.847 22.0782 107.558 20.8922 106.978 19.8993C106.427 18.8788 105.682 18.1065 104.744 17.5825C103.834 17.0584 102.841 16.7964 101.766 16.7964C100.718 16.7964 99.7246 17.0722 98.7869 17.6239C97.8767 18.1479 97.132 18.9202 96.5528 19.9407C96.0012 20.9612 95.7254 22.1609 95.7254 23.54C95.7254 24.9191 96.0012 26.1188 96.5528 27.1393C97.132 28.1598 97.8767 28.9459 98.7869 29.4975C99.7246 30.0216 100.718 30.2836 101.766 30.2836C102.841 30.2836 103.834 30.0078 104.744 29.4562C105.682 28.9045 106.427 28.1185 106.978 27.098C107.558 26.0775 107.847 24.8639 107.847 23.4573Z"
                        fill="currentColor"
                    />
                    <path
                        d="M126.743 35.3723C124.868 35.3723 123.185 35.0413 121.696 34.3794C120.206 33.6898 119.02 32.7659 118.138 31.6075C117.283 30.4491 116.814 29.1665 116.731 27.7599H122.565C122.675 28.6425 123.102 29.3734 123.847 29.9526C124.619 30.5318 125.571 30.8214 126.702 30.8214C127.805 30.8214 128.66 30.6008 129.267 30.1595C129.901 29.7182 130.218 29.1528 130.218 28.4632C130.218 27.7185 129.832 27.1669 129.06 26.8084C128.315 26.4222 127.115 26.0085 125.461 25.5672C123.751 25.1535 122.344 24.726 121.241 24.2847C120.165 23.8434 119.227 23.1677 118.427 22.2575C117.655 21.3473 117.269 20.1199 117.269 18.5754C117.269 17.3067 117.628 16.1483 118.345 15.1002C119.089 14.0521 120.137 13.2247 121.489 12.6179C122.868 12.0111 124.481 11.7077 126.329 11.7077C129.06 11.7077 131.239 12.3972 132.866 13.7763C134.493 15.1278 135.39 16.9619 135.555 19.2787H130.011C129.929 18.3685 129.543 17.6514 128.853 17.1274C128.191 16.5758 127.295 16.3 126.164 16.3C125.116 16.3 124.302 16.493 123.723 16.8792C123.171 17.2653 122.896 17.8031 122.896 18.4927C122.896 19.2649 123.282 19.8579 124.054 20.2716C124.826 20.6578 126.026 21.0577 127.653 21.4714C129.308 21.8851 130.673 22.3126 131.749 22.7539C132.825 23.1952 133.749 23.8848 134.521 24.8225C135.321 25.7327 135.735 26.9463 135.762 28.4632C135.762 29.7871 135.39 30.9731 134.645 32.0212C133.928 33.0693 132.88 33.8967 131.501 34.5035C130.149 35.0827 128.563 35.3723 126.743 35.3723Z"
                        fill="currentColor"
                    />
                    <path
                        d="M161.823 23.0435C161.823 23.871 161.768 24.6157 161.658 25.2776H144.902C145.04 26.9325 145.619 28.2288 146.64 29.1665C147.66 30.1043 148.915 30.5732 150.404 30.5732C152.556 30.5732 154.087 29.6492 154.997 27.8013H161.244C160.582 30.0078 159.313 31.8281 157.438 33.2623C155.562 34.669 153.259 35.3723 150.529 35.3723C148.322 35.3723 146.336 34.8896 144.571 33.9243C142.833 32.9314 141.468 31.5385 140.475 29.7458C139.51 27.953 139.027 25.8844 139.027 23.54C139.027 21.168 139.51 19.0857 140.475 17.2929C141.441 15.5001 142.792 14.1211 144.53 13.1557C146.267 12.1904 148.267 11.7077 150.529 11.7077C152.707 11.7077 154.652 12.1766 156.362 13.1143C158.1 14.0521 159.437 15.3898 160.375 17.1274C161.34 18.8374 161.823 20.8095 161.823 23.0435ZM155.824 21.3887C155.797 19.8993 155.259 18.7133 154.211 17.8307C153.163 16.9205 151.88 16.4655 150.363 16.4655C148.929 16.4655 147.715 16.9067 146.722 17.7893C145.757 18.6444 145.164 19.8441 144.943 21.3887H155.824Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <linearGradient
                        id="paint0_linear_815_40179"
                        x1="20.4827"
                        y1="0"
                        x2="20.4827"
                        y2="37.9178"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#55BFFA" />
                        <stop offset="1" stopColor="#0180FF" />
                    </linearGradient>
                    <clipPath id="clip0_815_40179">
                        <rect width="162" height="46" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        ),
        annotationQuestion: (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
            >
                <path
                    d="M10 8.50224C10.1762 8.00136 10.524 7.579 10.9817 7.30998C11.4395 7.04095 11.9777 6.9426 12.501 7.03237C13.0243 7.12213 13.499 7.39421 13.8409 7.80041C14.1829 8.20661 14.37 8.72072 14.3692 9.25168C14.3692 10.7506 12.1209 11.5 12.1209 11.5M12.1499 14.5H12.1599M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        announcement: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
            >
                <path
                    d="M4 14.2925L5.57465 20.591C5.61893 20.7682 5.64107 20.8567 5.66727 20.9341C5.92317 21.6896 6.60352 22.2208 7.39852 22.2858C7.4799 22.2925 7.5712 22.2925 7.75379 22.2925C7.98244 22.2925 8.09677 22.2925 8.19308 22.2831C9.145 22.1908 9.89834 21.4374 9.99066 20.4855C10 20.3892 10 20.2749 10 20.0462V5.79245M18.5 13.7925C20.433 13.7925 22 12.2254 22 10.2925C22 8.35946 20.433 6.79245 18.5 6.79245M10.25 5.79245H6.5C4.01472 5.79245 2 7.80717 2 10.2925C2 12.7777 4.01472 14.7925 6.5 14.7925H10.25C12.0164 14.7925 14.1772 15.7393 15.8443 16.6481C16.8168 17.1783 17.3031 17.4433 17.6216 17.4043C17.9169 17.3682 18.1402 17.2356 18.3133 16.9936C18.5 16.7326 18.5 16.2105 18.5 15.1662V5.41874C18.5 4.37445 18.5 3.8523 18.3133 3.59134C18.1402 3.34935 17.9169 3.21675 17.6216 3.18058C17.3031 3.14157 16.8168 3.40665 15.8443 3.93681C14.1772 4.84557 12.0164 5.79245 10.25 5.79245Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        x: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill={fill || "none"}
                color={color}
            >
                <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        arrowRight: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18L15 12L9 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        folder: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        arrowUp: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20V4M12 4L6 10M12 4L18 10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        copy: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        check: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        filter: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M6 12H18M3 6H21M9 18H15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        checkCertified: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="25"
                height="25"
                viewBox="0 0 25 25"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.5 12.5L11.5 14.5L16 10M18.4012 5.49851C18.6071 5.99653 19.0024 6.3924 19.5001 6.59907L21.2452 7.32198C21.7433 7.52828 22.139 7.92399 22.3453 8.42206C22.5516 8.92012 22.5516 9.47974 22.3453 9.97781L21.6229 11.7218C21.4165 12.2201 21.4162 12.7803 21.6236 13.2783L22.3447 15.0218C22.4469 15.2685 22.4996 15.5329 22.4996 15.7999C22.4997 16.067 22.4471 16.3314 22.3449 16.5781C22.2427 16.8249 22.0929 17.049 21.9041 17.2378C21.7152 17.4266 21.491 17.5764 21.2443 17.6785L19.5004 18.4009C19.0023 18.6068 18.6065 19.0021 18.3998 19.4998L17.6769 21.245C17.4706 21.7431 17.075 22.1388 16.5769 22.3451C16.0789 22.5514 15.5193 22.5514 15.0212 22.3451L13.2773 21.6227C12.7792 21.4169 12.2198 21.4173 11.7221 21.6239L9.97689 22.3458C9.47912 22.5516 8.92001 22.5514 8.42237 22.3453C7.92473 22.1391 7.52925 21.7439 7.32281 21.2464L6.59972 19.5006C6.3938 19.0026 5.99854 18.6067 5.50085 18.4L3.75566 17.6771C3.25783 17.4709 2.86226 17.0754 2.65588 16.5777C2.44951 16.0799 2.44923 15.5205 2.6551 15.0225L3.37746 13.2786C3.58325 12.7805 3.58283 12.2211 3.3763 11.7233L2.65497 9.97678C2.5527 9.7301 2.50004 9.46568 2.5 9.19863C2.49996 8.93159 2.55253 8.66715 2.65472 8.42043C2.75691 8.17372 2.90671 7.94955 3.09557 7.76075C3.28442 7.57195 3.50862 7.42222 3.75537 7.3201L5.4993 6.59772C5.99687 6.39197 6.39248 5.9972 6.5993 5.50006L7.32218 3.75481C7.52848 3.25674 7.92418 2.86103 8.42222 2.65473C8.92027 2.44842 9.47987 2.44842 9.97792 2.65473L11.7218 3.37712C12.2199 3.58291 12.7793 3.58249 13.2771 3.37595L15.023 2.65585C15.521 2.44966 16.0804 2.4497 16.5784 2.65597C17.0763 2.86223 17.472 3.25783 17.6783 3.75576L18.4014 5.50153L18.4012 5.49851Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        code: (
            <SvgIcon
                sx={{ fill: "none" }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.66926 16.5922C5.05978 16.9827 5.69295 16.9827 6.08347 16.5922C6.474 16.2017 6.474 15.5685 6.08347 15.178L4.66926 16.5922ZM1.77637 12.2851L1.06926 11.578C0.678736 11.9685 0.678736 12.6017 1.06926 12.9922L1.77637 12.2851ZM6.08347 9.39221C6.474 9.00169 6.474 8.36853 6.08347 7.978C5.69295 7.58748 5.05978 7.58748 4.66926 7.978L6.08347 9.39221ZM18.0841 7.978C17.6935 7.58748 17.0604 7.58748 16.6698 7.978C16.2793 8.36852 16.2793 9.00169 16.6698 9.39221L18.0841 7.978ZM20.977 12.2851L21.6841 12.9922C22.0746 12.6017 22.0746 11.9685 21.6841 11.578L20.977 12.2851ZM16.6698 15.178C16.2793 15.5685 16.2793 16.2017 16.6698 16.5922C17.0604 16.9827 17.6935 16.9827 18.0841 16.5922L16.6698 15.178ZM8.69449 18.4627C8.55223 18.9964 8.86951 19.5443 9.40316 19.6865C9.93681 19.8288 10.4847 19.5115 10.627 18.9779L8.69449 18.4627ZM11.3764 12.2845L10.4108 12.0245L10.4101 12.0269L11.3764 12.2845ZM14.1402 5.86646C14.2838 5.33317 13.9679 4.78444 13.4346 4.64084C12.9013 4.49724 12.3526 4.81315 12.209 5.34643L14.1402 5.86646ZM6.08347 15.178L2.48347 11.578L1.06926 12.9922L4.66926 16.5922L6.08347 15.178ZM2.48347 12.9922L6.08347 9.39221L4.66926 7.978L1.06926 11.578L2.48347 12.9922ZM16.6698 9.39221L20.2698 12.9922L21.6841 11.578L18.0841 7.978L16.6698 9.39221ZM20.2698 11.578L16.6698 15.178L18.0841 16.5922L21.6841 12.9922L20.2698 11.578ZM10.627 18.9779L12.3426 12.5421L10.4101 12.0269L8.69449 18.4627L10.627 18.9779ZM12.342 12.5445L14.1402 5.86646L12.209 5.34643L10.4108 12.0245L12.342 12.5445Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        annotationChecked: (
            <SvgIcon
                sx={{ fill: "none" }}
                width="36"
                height="36"
                viewBox="0 0 36 36"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.625 16.5417L16.5417 19.4583L23.1042 12.8958M14.9375 28.5L17.0667 31.3389C17.3833 31.7611 17.5416 31.9722 17.7357 32.0476C17.9057 32.1138 18.0943 32.1138 18.2643 32.0476C18.4584 31.9722 18.6167 31.7611 18.9333 31.3389L21.0625 28.5C21.49 27.93 21.7038 27.645 21.9645 27.4274C22.3121 27.1373 22.7225 26.9321 23.1632 26.828C23.4937 26.75 23.85 26.75 24.5625 26.75C26.601 26.75 27.6202 26.75 28.4242 26.417C29.4962 25.9729 30.3479 25.1212 30.792 24.0492C31.125 23.2452 31.125 22.226 31.125 20.1875V11.875C31.125 9.42477 31.125 8.19966 30.6482 7.26379C30.2287 6.44058 29.5594 5.77129 28.7362 5.35185C27.8003 4.875 26.5752 4.875 24.125 4.875H11.875C9.42477 4.875 8.19966 4.875 7.26379 5.35185C6.44058 5.77129 5.77129 6.44058 5.35185 7.26379C4.875 8.19966 4.875 9.42477 4.875 11.875V20.1875C4.875 22.226 4.875 23.2452 5.20803 24.0492C5.65206 25.1212 6.50376 25.9729 7.57576 26.417C8.37976 26.75 9.39901 26.75 11.4375 26.75C12.15 26.75 12.5063 26.75 12.8368 26.828C13.2775 26.9321 13.6879 27.1373 14.0355 27.4274C14.2962 27.645 14.51 27.93 14.9375 28.5Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        bold: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="10"
                height="12"
                viewBox="0 0 10 12"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 6H6C7.38071 6 8.5 4.88071 8.5 3.5C8.5 2.11929 7.38071 1 6 1H1V6ZM1 6H6.625C8.00571 6 9.125 7.11929 9.125 8.5C9.125 9.88071 8.00571 11 6.625 11H1V6Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        italic: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="10"
                height="12"
                viewBox="0 0 10 12"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.4644 1H4.83936M7.33936 11H1.71436M7.96436 1L4.21436 11"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        underline: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="13"
                height="14"
                viewBox="0 0 13 14"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.5232 1.5V6.02941C10.5232 8.17358 8.78499 9.91176 6.64083 9.91176C4.49666 9.91176 2.75847 8.17358 2.75847 6.02941V1.5M1.46436 12.5H11.8173"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        strikethrough: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="14"
                height="12"
                viewBox="0 0 14 12"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.33936 8.5C3.33936 9.88071 4.45864 11 5.83936 11H8.33936C9.72007 11 10.8394 9.88071 10.8394 8.5C10.8394 7.11929 9.72007 6 8.33936 6M10.8394 3.5C10.8394 2.11929 9.72007 1 8.33936 1H5.83936C4.45864 1 3.33936 2.11929 3.33936 3.5M1.46436 6H12.7144"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        bulletList: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                sx={sx}
                className={className}
            >
                <path
                    d="M21.5 12L9.5 12M21.5 6L9.5 6M21.5 18L9.5 18M5.5 12C5.5 12.5523 5.05228 13 4.5 13C3.94772 13 3.5 12.5523 3.5 12C3.5 11.4477 3.94772 11 4.5 11C5.05228 11 5.5 11.4477 5.5 12ZM5.5 6C5.5 6.55228 5.05228 7 4.5 7C3.94772 7 3.5 6.55228 3.5 6C3.5 5.44772 3.94772 5 4.5 5C5.05228 5 5.5 5.44772 5.5 6ZM5.5 18C5.5 18.5523 5.05228 19 4.5 19C3.94772 19 3.5 18.5523 3.5 18C3.5 17.4477 3.94772 17 4.5 17C5.05228 17 5.5 17.4477 5.5 18Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        clearMarks: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 2.875C1 2.29257 1 2.00136 1.09515 1.77165C1.22202 1.46536 1.46536 1.22202 1.77165 1.09515C2.00136 1 2.29257 1 2.875 1H9.125C9.70743 1 9.99864 1 10.2284 1.09515C10.5346 1.22202 10.778 1.46536 10.9048 1.77165C11 2.00136 11 2.29257 11 2.875M4.125 11H7.875M6 1V11"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        model: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11 10H5M7 14H5M13 6H5M17 5.8V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.2C13.8802 1 14.7202 1 15.362 1.32698C15.9265 1.6146 16.3854 2.07354 16.673 2.63803C17 3.27976 17 4.11984 17 5.8Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        ellipse: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="6" cy="6.5" r="6" fill="currentColor" />
            </SvgIcon>
        ),
        search: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        data: (
            <svg width="78" height="74" viewBox="0 0 78 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M74.9177 16.9981C74.9177 24.476 58.7521 30.5381 38.8109 30.5381C18.8697 30.5381 2.7041 24.476 2.7041 16.9981M74.9177 16.9981C74.9177 9.5201 58.7521 3.45801 38.8109 3.45801C18.8697 3.45801 2.7041 9.5201 2.7041 16.9981M74.9177 16.9981V57.6182C74.9177 65.0962 58.7521 71.1583 38.8109 71.1583C18.8697 71.1583 2.7041 65.0962 2.7041 57.6182V16.9981M74.9177 37.3081C74.9177 44.7861 58.7521 50.8482 38.8109 50.8482C18.8697 50.8482 2.7041 44.7861 2.7041 37.3081"
                    stroke="#5B7DD8"
                    strokeOpacity="0.16"
                    strokeWidth="5"
                />
            </svg>
        ),
        envelope: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="23"
                height="19"
                viewBox="0 0 23 19"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.91663 4.48145L9.74134 10.1969C10.375 10.6597 10.6918 10.8911 11.0364 10.9808C11.3408 11.0599 11.6591 11.0599 11.9635 10.9808C12.3081 10.8911 12.625 10.6597 13.2586 10.1969L21.0833 4.48145M6.51663 17.4814H16.4833C18.0934 17.4814 18.8985 17.4814 19.5135 17.1545C20.0545 16.8668 20.4943 16.4079 20.7699 15.8434C21.0833 15.2017 21.0833 14.3616 21.0833 12.6814V6.28145C21.0833 4.60129 21.0833 3.76121 20.7699 3.11947C20.4943 2.55499 20.0545 2.09605 19.5135 1.80843C18.8985 1.48145 18.0934 1.48145 16.4833 1.48145H6.51663C4.90648 1.48145 4.1014 1.48145 3.4864 1.80843C2.94544 2.09605 2.50562 2.55499 2.22998 3.11947C1.91663 3.76121 1.91663 4.60129 1.91663 6.28145V12.6814C1.91663 14.3616 1.91663 15.2017 2.22998 15.8434C2.50562 16.4079 2.94544 16.8668 3.4864 17.1545C4.1014 17.4814 4.90648 17.4814 6.51663 17.4814Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        lock: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="19"
                height="21"
                viewBox="0 0 19 21"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.2917 8.48145V6.48145C14.2917 3.72002 12.1464 1.48145 9.50004 1.48145C6.85368 1.48145 4.70837 3.72002 4.70837 6.48145V8.48145M9.50004 12.9814V14.9814M6.43337 19.4814H12.5667C14.1769 19.4814 14.9819 19.4814 15.5969 19.1545C16.1379 18.8668 16.5777 18.4079 16.8534 17.8434C17.1667 17.2017 17.1667 16.3616 17.1667 14.6814V13.2814C17.1667 11.6013 17.1667 10.7612 16.8534 10.1195C16.5777 9.55499 16.1379 9.09605 15.5969 8.80843C14.9819 8.48145 14.1769 8.48145 12.5667 8.48145H6.43337C4.82322 8.48145 4.01815 8.48145 3.40315 8.80843C2.86219 9.09605 2.42237 9.55499 2.14673 10.1195C1.83337 10.7612 1.83337 11.6013 1.83337 13.2814V14.6814C1.83337 16.3616 1.83337 17.2017 2.14673 17.8434C2.42237 18.4079 2.86219 18.8668 3.40315 19.1545C4.01815 19.4814 4.82322 19.4814 6.43337 19.4814Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        ca: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="25"
                height="24"
                viewBox="0 0 25 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_3837_187030)">
                    <mask id="mask0_3837_187030" maskUnits="userSpaceOnUse" x="1" y="4" width="23" height="16">
                        <path
                            d="M21.1348 4H3.865C2.7429 4 1.83325 4.95513 1.83325 6.13333V17.8667C1.83325 19.0449 2.7429 20 3.865 20H21.1348C22.2569 20 23.1666 19.0449 23.1666 17.8667V6.13333C23.1666 4.95513 22.2569 4 21.1348 4Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_3837_187030)">
                        <path
                            d="M21.1348 4H3.865C2.7429 4 1.83325 4.95513 1.83325 6.13333V17.8667C1.83325 19.0449 2.7429 20 3.865 20H21.1348C22.2569 20 23.1666 19.0449 23.1666 17.8667V6.13333C23.1666 4.95513 22.2569 4 21.1348 4Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.83325 4H6.91262V20H1.83325V4ZM18.0872 4H23.1666V20H18.0872V4ZM12.4999 8.26667L11.484 10.4L9.96024 9.33333V11.4667L8.94436 12.5333L10.9761 13.6H11.992V15.7333H13.0079V13.6H14.0237L16.0555 12.5333L15.0396 11.4667V9.33333L13.4142 10.4L12.4999 8.26667Z"
                            fill="#FF0000"
                        />
                        <path
                            d="M21.135 4.53333H3.86512C3.02354 4.53333 2.34131 5.24967 2.34131 6.13333V17.8667C2.34131 18.7503 3.02354 19.4667 3.86512 19.4667H21.135C21.9765 19.4667 22.6588 18.7503 22.6588 17.8667V6.13333C22.6588 5.24967 21.9765 4.53333 21.135 4.53333Z"
                            stroke="black"
                            strokeOpacity="0.1"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_3837_187030">
                        <rect width="21.3333" height="16" fill="white" transform="translate(1.83325 4)" />
                    </clipPath>
                </defs>
            </SvgIcon>
        ),
        arrowLeft: (
            <SvgIcon
                sx={{ fill: fill || "none", ...sx }}
                className={className}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill={fill || "none"}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 18L9 12L15 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        back: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                    d="M20 24L12 16L20 8"
                    stroke="#0180FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        save: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.5 8H9.1C8.53995 8 8.25992 8 8.04601 7.89101C7.85785 7.79513 7.70487 7.64215 7.60899 7.45399C7.5 7.24008 7.5 6.96005 7.5 6.4V3M17.5 21V14.6C17.5 14.0399 17.5 13.7599 17.391 13.546C17.2951 13.3578 17.1422 13.2049 16.954 13.109C16.7401 13 16.4601 13 15.9 13H9.1C8.53995 13 8.25992 13 8.04601 13.109C7.85785 13.2049 7.70487 13.3578 7.60899 13.546C7.5 13.7599 7.5 14.0399 7.5 14.6V21M21.5 9.32548V16.2C21.5 17.8802 21.5 18.7202 21.173 19.362C20.8854 19.9265 20.4265 20.3854 19.862 20.673C19.2202 21 18.3802 21 16.7 21H8.3C6.61984 21 5.77976 21 5.13803 20.673C4.57354 20.3854 4.1146 19.9265 3.82698 19.362C3.5 18.7202 3.5 17.8802 3.5 16.2V7.8C3.5 6.11984 3.5 5.27976 3.82698 4.63803C4.1146 4.07354 4.57354 3.6146 5.13803 3.32698C5.77976 3 6.61984 3 8.3 3H15.1745C15.6637 3 15.9083 3 16.1385 3.05526C16.3425 3.10425 16.5376 3.18506 16.7166 3.29472C16.9184 3.4184 17.0914 3.59135 17.4373 3.93726L20.5627 7.06274C20.9086 7.40865 21.0816 7.5816 21.2053 7.78343C21.3149 7.96237 21.3957 8.15746 21.4447 8.36154C21.5 8.59171 21.5 8.8363 21.5 9.32548Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        write: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 4.00023H6.8C5.11984 4.00023 4.27976 4.00023 3.63803 4.32721C3.07354 4.61483 2.6146 5.07377 2.32698 5.63826C2 6.27999 2 7.12007 2 8.80023V17.2002C2 18.8804 2 19.7205 2.32698 20.3622C2.6146 20.9267 3.07354 21.3856 3.63803 21.6732C4.27976 22.0002 5.11984 22.0002 6.8 22.0002H15.2C16.8802 22.0002 17.7202 22.0002 18.362 21.6732C18.9265 21.3856 19.3854 20.9267 19.673 20.3622C20 19.7205 20 18.8804 20 17.2002V13.0002M7.99997 16.0002H9.67452C10.1637 16.0002 10.4083 16.0002 10.6385 15.945C10.8425 15.896 11.0376 15.8152 11.2166 15.7055C11.4184 15.5818 11.5914 15.4089 11.9373 15.063L21.5 5.50023C22.3284 4.6718 22.3284 3.32865 21.5 2.50023C20.6716 1.6718 19.3284 1.6718 18.5 2.50022L8.93723 12.063C8.59133 12.4089 8.41838 12.5818 8.29469 12.7837C8.18504 12.9626 8.10423 13.1577 8.05523 13.3618C7.99997 13.5919 7.99997 13.8365 7.99997 14.3257V16.0002Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        socialNetwork: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M16.2426 7.75811C18.5858 10.1013 18.5858 13.9002 16.2426 16.2434M7.75736 16.2434C5.41421 13.9002 5.41421 10.1012 7.75736 7.75808M4.92893 19.0718C1.02369 15.1666 1.02369 8.83493 4.92893 4.92969M19.0711 4.92973C22.9763 8.83498 22.9763 15.1666 19.0711 19.0719M14 12.0008C14 13.1053 13.1046 14.0008 12 14.0008C10.8954 14.0008 10 13.1053 10 12.0008C10 10.8962 10.8954 10.0008 12 10.0008C13.1046 10.0008 14 10.8962 14 12.0008Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        facebook: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                className={className}
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.5555 10.0541C19.5555 5.11539 15.5754 1.11111 10.6666 1.11111C5.75777 1.11111 1.77771 5.11539 1.77771 10.0541C1.77771 14.5173 5.02776 18.2173 9.27782 18.8889V12.6397H7.02029V10.0541H9.27782V8.08337C9.27782 5.84229 10.6053 4.60353 12.6354 4.60353C13.6079 4.60353 14.6254 4.77834 14.6254 4.77834V6.97918H13.5042C12.4003 6.97918 12.0554 7.66836 12.0554 8.37639V10.0541H14.5204L14.1266 12.6397H12.0554V18.8889C16.3055 18.2186 19.5555 14.5186 19.5555 10.0541Z"
                    fill="#4285F4"
                />
            </SvgIcon>
        ),
        instagram: (
            <div className="div-img">
                <img src={instaIcon} width={20} />
            </div>
        ),
        linkedin: (
            <div className="div-img">
                <img src={linkedinIcon} width={20} />
            </div>
        ),
        tiktok: (
            <div className="div-img">
                <img src={tiktokIcon} width={20} />
            </div>
        ),
        twitter: (
            <div className="div-img">
                <img src={twitterIcon} width={"20"} />
            </div>
        ),
        youtube: (
            <div className="div-img">
                <img src={youtubeIcon} className="youtube" width={"21"} />
            </div>
        ),
        ravenLogo: (
            <div className="div-img">
                <img src={ravenLogo} />
            </div>
        ),
        pinterest: (
            <div className="div-img">
                <img src={pinterestIcon} width={"21"} />
            </div>
        ),
        success: (
            <Stack className="div-img" sx={sx}>
                <img src={success} />
            </Stack>
        ),
        scheduled: (
            <Stack className="div-img" sx={sx}>
                <img src={scheduled} />
            </Stack>
        ),
        phoneIncoming: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M16.4996 3L12.9996 6.5M12.9996 6.5L16.4996 10M12.9996 6.5H20.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        atSign: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M16 8.00036V13.0004C16 13.796 16.3161 14.5591 16.8787 15.1217C17.4413 15.6843 18.2044 16.0004 19 16.0004C19.7957 16.0004 20.5587 15.6843 21.1213 15.1217C21.6839 14.5591 22 13.796 22 13.0004V12.0004C21.9999 9.74339 21.2362 7.55283 19.8333 5.78489C18.4303 4.01694 16.4706 2.77558 14.2726 2.26265C12.0747 1.74973 9.76794 1.9954 7.72736 2.95972C5.68677 3.92405 4.03241 5.55031 3.03327 7.57408C2.03413 9.59785 1.74898 11.9001 2.22418 14.1065C2.69938 16.3128 3.90699 18.2936 5.65064 19.7266C7.39429 21.1597 9.57144 21.9607 11.8281 21.9995C14.0847 22.0383 16.2881 21.3126 18.08 19.9404M16 12.0004C16 14.2095 14.2092 16.0004 12 16.0004C9.79087 16.0004 8.00001 14.2095 8.00001 12.0004C8.00001 9.79122 9.79087 8.00036 12 8.00036C14.2092 8.00036 16 9.79122 16 12.0004Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        unicolorGoogle: (
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.7865 5.86464C12.8653 4.98384 11.6935 4.53536 10.3885 4.53536C8.07378 4.53536 6.11448 6.09842 5.41515 8.19885V8.19981C5.23737 8.73315 5.13637 9.30284 5.13637 9.8887C5.13637 10.4746 5.23737 11.0442 5.41515 11.5776L5.41478 11.5778C6.11379 13.6788 8.07337 15.2424 10.3885 15.2424C11.5845 15.2424 12.6027 14.9272 13.3986 14.3939L13.399 14.3942V14.3933C14.3404 13.763 14.9667 12.8216 15.1727 11.7105H10.3889V8.27213H18.7607C18.8657 8.85395 18.9222 9.46001 18.9222 10.0903C18.9222 12.7974 17.9526 15.0762 16.2718 16.6237H16.2706L16.2713 16.6242C14.8006 17.9818 12.7885 18.7778 10.3885 18.7778C6.91376 18.7778 3.90769 16.7858 2.44507 13.8808V13.8798C1.84329 12.68 1.5 11.3227 1.5 9.8887C1.5 8.45449 1.84337 7.09705 2.44528 5.89713L2.44507 5.89697C3.90769 2.99192 6.91376 1 10.3885 1C12.7845 1 14.7965 1.88081 16.336 3.31515L13.7865 5.86464Z"
                    fill="currentColor"
                />
            </svg>
        ),
        unicolorFacebook: (
            <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
            >
                <path
                    d="M19.3889 10.0541C19.3889 5.11539 15.4088 1.11111 10.5 1.11111C5.59115 1.11111 1.61108 5.11539 1.61108 10.0541C1.61108 14.5173 4.86114 18.2173 9.1112 18.8889V12.6397H6.85366V10.0541H9.1112V8.08337C9.1112 5.84229 10.4387 4.60353 12.4688 4.60353C13.4413 4.60353 14.4588 4.77834 14.4588 4.77834V6.97918H13.3375C12.2337 6.97918 11.8887 7.66836 11.8887 8.37639V10.0541H14.3538L13.96 12.6397H11.8887V18.8889C16.1388 18.2186 19.3889 14.5186 19.3889 10.0541Z"
                    fill="currentColor"
                />
            </svg>
        ),
        checkCircle: (
            <SvgIcon
                sx={{ fill: "none", width: 18, height: 18, color, ...sx }}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        refreshCircle: (
            <SvgIcon
                sx={{ width: 18, height: 18, fill: "none", color, ...sx }}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14 2C14 2 14.8492 2.12132 18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.364C17.1187 19.6092 15.5993 20.4133 14 20.7762M14 2L20 2M14 2L14 8M10 21.9998C10 21.9998 9.15076 21.8785 5.63604 18.3638C2.12132 14.849 2.12132 9.15056 5.63604 5.63584C6.88131 4.39057 8.40072 3.5865 10 3.22363M10 21.9998L4 22M10 21.9998L10 16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        plusCircle: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        clock: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        link: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M12.7076 18.3644L11.2933 19.7786C9.34072 21.7313 6.1749 21.7313 4.22228 19.7786C2.26966 17.826 2.26966 14.6602 4.22228 12.7076L5.63649 11.2933M18.3644 12.7076L19.7786 11.2933C21.7312 9.34072 21.7312 6.1749 19.7786 4.22228C17.826 2.26966 14.6602 2.26966 12.7076 4.22228L11.2933 5.63649M8.50045 15.5004L15.5005 8.50043"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        file: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        category: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M21 11L13.4059 3.40589C12.887 2.88703 12.6276 2.6276 12.3249 2.44208C12.0564 2.27759 11.7638 2.15638 11.4577 2.08289C11.1124 2 10.7455 2 10.0118 2L6 2M3 8.7L3 10.6745C3 11.1637 3 11.4083 3.05526 11.6385C3.10425 11.8425 3.18506 12.0376 3.29472 12.2166C3.4184 12.4184 3.59136 12.5914 3.93726 12.9373L11.7373 20.7373C12.5293 21.5293 12.9253 21.9253 13.382 22.0737C13.7837 22.2042 14.2163 22.2042 14.618 22.0737C15.0747 21.9253 15.4707 21.5293 16.2627 20.7373L18.7373 18.2627C19.5293 17.4707 19.9253 17.0747 20.0737 16.618C20.2042 16.2163 20.2042 15.7837 20.0737 15.382C19.9253 14.9253 19.5293 14.5293 18.7373 13.7373L11.4373 6.43726C11.0914 6.09136 10.9184 5.9184 10.7166 5.79472C10.5376 5.68506 10.3425 5.60425 10.1385 5.55526C9.90829 5.5 9.6637 5.5 9.17452 5.5H6.2C5.0799 5.5 4.51984 5.5 4.09202 5.71799C3.7157 5.90973 3.40973 6.21569 3.21799 6.59202C3 7.01984 3 7.57989 3 8.7Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        building: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M11 11H6.2C5.07989 11 4.51984 11 4.09202 11.218C3.71569 11.4097 3.40973 11.7157 3.21799 12.092C3 12.5198 3 13.0799 3 14.2V21M21 21V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H14.2C13.0799 3 12.5198 3 12.092 3.21799C11.7157 3.40973 11.4097 3.71569 11.218 4.09202C11 4.51984 11 5.0799 11 6.2V21M22 21H2M14.5 7H17.5M14.5 11H17.5M14.5 15H17.5"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        map: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M8 3L16 21M3 17L12 12M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        calendar: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        contact: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.6666 17.5C16.6666 16.337 16.6666 15.7555 16.5231 15.2824C16.1999 14.217 15.3662 13.3834 14.3009 13.0602C13.8277 12.9167 13.2462 12.9167 12.0832 12.9167H7.91659C6.75362 12.9167 6.17213 12.9167 5.69897 13.0602C4.63363 13.3834 3.79995 14.217 3.47678 15.2824C3.33325 15.7555 3.33325 16.337 3.33325 17.5M13.7499 6.25C13.7499 8.32107 12.071 10 9.99992 10C7.92885 10 6.24992 8.32107 6.24992 6.25C6.24992 4.17893 7.92885 2.5 9.99992 2.5C12.071 2.5 13.7499 4.17893 13.7499 6.25Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        phone: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        calendarCheck: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="23"
                height="23"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.22461 9.18164H19.9746M6.26032 2.71289V4.4006M17.7246 2.71289V4.40039M17.7246 4.40039H6.47461C4.61065 4.40039 3.09961 5.91143 3.09961 7.77539V19.0255C3.09961 20.8895 4.61065 22.4005 6.47461 22.4005H17.7246C19.5886 22.4005 21.0996 20.8895 21.0996 19.0255L21.0996 7.77539C21.0996 5.91143 19.5886 4.40039 17.7246 4.40039ZM9.28711 15.9317L10.9746 17.6192L14.9121 13.6817"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        thumbsUp: (
            <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                className={className}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 22.5V11.5M2 13.5V20.5C2 21.6046 2.89543 22.5 4 22.5H17.4262C18.907 22.5 20.1662 21.4197 20.3914 19.9562L21.4683 12.9562C21.7479 11.1389 20.3418 9.5 18.5032 9.5H15C14.4477 9.5 14 9.05228 14 8.5V4.96584C14 3.60399 12.896 2.5 11.5342 2.5C11.2093 2.5 10.915 2.6913 10.7831 2.98812L7.26394 10.9061C7.10344 11.2673 6.74532 11.5 6.35013 11.5H4C2.89543 11.5 2 12.3954 2 13.5Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        imagePlaceholder: (
            <svg
                data-testid="image-svg"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M16.2 21H6.93137C6.32555 21 6.02265 21 5.88238 20.8802C5.76068 20.7763 5.69609 20.6203 5.70865 20.4608C5.72312 20.2769 5.93731 20.0627 6.36569 19.6343L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21 15V16.2M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        imagePlus: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                sx={{ fill: "none", height: 24, width: 24, ...sx }}
                viewBox="0 0 24 24"
                className={className}
            >
                <path
                    d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        fileAttachment: (
            <SvgIcon
                sx={{ width: 32, height: 32, fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                fill="none"
            >
                <path
                    d="M26.6668 9.33317V9.0665C26.6668 6.82629 26.6668 5.70619 26.2309 4.85054C25.8474 4.09789 25.2354 3.48597 24.4828 3.10248C23.6271 2.6665 22.507 2.6665 20.2668 2.6665H11.7335C9.49329 2.6665 8.37318 2.6665 7.51753 3.10248C6.76489 3.48597 6.15296 4.09789 5.76947 4.85054C5.3335 5.70619 5.3335 6.82629 5.3335 9.0665V22.9332C5.3335 25.1734 5.3335 26.2935 5.76947 27.1491C6.15296 27.9018 6.76489 28.5137 7.51753 28.8972C8.37318 29.3332 9.49329 29.3332 11.7335 29.3332H16.6668M16.6668 14.6665H10.6668M15.3335 19.9998H10.6668M21.3335 9.33317H10.6668M24.0002 23.9998V16.6665C24.0002 15.5619 24.8956 14.6665 26.0002 14.6665C27.1047 14.6665 28.0002 15.5619 28.0002 16.6665V23.9998C28.0002 26.209 26.2093 27.9998 24.0002 27.9998C21.791 27.9998 20.0002 26.209 20.0002 23.9998V18.6665"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        activity: (
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22 12.056H18L15 21.056L9 3.056L6 12.056H2"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        logOut: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17.0001C6 17.3514 6 17.527 6.01567 17.6797C6.14575 18.9475 7.0626 19.9947 8.30206 20.2912C8.45134 20.3269 8.6255 20.3501 8.97368 20.3966L15.5656 21.2755C17.442 21.5257 18.3803 21.6508 19.1084 21.3612C19.7478 21.107 20.2803 20.6408 20.6168 20.0407C21 19.3572 21 18.4106 21 16.5176V7.48256C21 5.58952 21 4.643 20.6168 3.95947C20.2803 3.35936 19.7478 2.89313 19.1084 2.63892C18.3803 2.34938 17.442 2.47448 15.5656 2.72467L8.97368 3.60359C8.62546 3.65002 8.45135 3.67324 8.30206 3.70895C7.0626 4.00544 6.14575 5.05266 6.01567 6.32043C6 6.47313 6 6.64878 6 7.00008M12 8.00008L16 12.0001M16 12.0001L12 16.0001M16 12.0001H3"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        user: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22 21.2926V19.2926C22 17.4288 20.7252 15.8627 19 15.4186M15.5 3.58336C16.9659 4.17675 18 5.61391 18 7.2926C18 8.97129 16.9659 10.4085 15.5 11.0018M17 21.2926C17 19.4288 17 18.497 16.6955 17.7619C16.2895 16.7818 15.5108 16.0031 14.5307 15.5971C13.7956 15.2926 12.8638 15.2926 11 15.2926H8C6.13623 15.2926 5.20435 15.2926 4.46927 15.5971C3.48915 16.0031 2.71046 16.7818 2.30448 17.7619C2 18.497 2 19.4288 2 21.2926M13.5 7.2926C13.5 9.50174 11.7091 11.2926 9.5 11.2926C7.29086 11.2926 5.5 9.50174 5.5 7.2926C5.5 5.08346 7.29086 3.2926 9.5 3.2926C11.7091 3.2926 13.5 5.08346 13.5 7.2926Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        "alert-triangle": (
            <SvgIcon
                sx={{ width: 24, height: 24, fill: "none", ...sx }}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        edit: (
            <SvgIcon
                sx={{ width: 24, height: 24, fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M12 20.0002H21M3 20.0002H4.67454C5.16372 20.0002 5.40832 20.0002 5.63849 19.945C5.84256 19.896 6.03765 19.8152 6.2166 19.7055C6.41843 19.5818 6.59138 19.4089 6.93729 19.063L19.5 6.50023C20.3285 5.6718 20.3285 4.32865 19.5 3.50023C18.6716 2.6718 17.3285 2.6718 16.5 3.50023L3.93726 16.063C3.59136 16.4089 3.4184 16.5818 3.29472 16.7837C3.18506 16.9626 3.10425 17.1577 3.05526 17.3618C3 17.5919 3 17.8365 3 18.3257V20.0002Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        delete1: (
            <SvgIcon
                sx={{ width: 24, height: 24, fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
            >
                <path
                    d="M9 3.5H15M3 6.5H21M19 6.5L18.2987 17.0193C18.1935 18.5975 18.1409 19.3867 17.8 19.985C17.4999 20.5118 17.0472 20.9353 16.5017 21.1997C15.882 21.5 15.0911 21.5 13.5093 21.5H10.4907C8.90891 21.5 8.11803 21.5 7.49834 21.1997C6.95276 20.9353 6.50009 20.5118 6.19998 19.985C5.85911 19.3867 5.8065 18.5975 5.70129 17.0193L5 6.5M10 11V16M14 11V16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        company: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M11 11.2925H6.2C5.07989 11.2925 4.51984 11.2925 4.09202 11.5105C3.71569 11.7022 3.40973 12.0082 3.21799 12.3845C3 12.8123 3 13.3724 3 14.4925V21.2925M21 21.2925V6.49248C21 5.37238 21 4.81232 20.782 4.3845C20.5903 4.00818 20.2843 3.70221 19.908 3.51047C19.4802 3.29248 18.9201 3.29248 17.8 3.29248H14.2C13.0799 3.29248 12.5198 3.29248 12.092 3.51047C11.7157 3.70221 11.4097 4.00818 11.218 4.3845C11 4.81232 11 5.37238 11 6.49248V21.2925M22 21.2925H2M14.5 7.29248H17.5M14.5 11.2925H17.5M14.5 15.2925H17.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        checkboxFilled: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                    d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.7583 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM8.33333 14.1667L4.16667 10L5.34167 8.825L8.33333 11.8083L14.6583 5.48333L15.8333 6.66667L8.33333 14.1667Z"
                    fill="#0180FF"
                />
            </svg>
        ),
        cancelFilled: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                    <path
                        d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.295 14.885C16.6844 15.2744 16.6844 15.9056 16.295 16.295C15.9056 16.6844 15.2744 16.6844 14.885 16.295L12 13.41L9.115 16.295C8.72564 16.6844 8.09436 16.6844 7.705 16.295C7.31564 15.9056 7.31564 15.2744 7.705 14.885L10.59 12L7.705 9.115C7.31564 8.72564 7.31564 8.09436 7.705 7.705C8.09436 7.31564 8.72564 7.31564 9.115 7.705L12 10.59L14.885 7.705C15.2744 7.31564 15.9056 7.31564 16.295 7.705C16.6844 8.09436 16.6844 8.72564 16.295 9.115L13.41 12L16.295 14.885Z"
                        fill="white"
                    />
                </g>
            </svg>
        ),
        annotationInfo: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 14V10.5M12 7H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        tag: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        flagCa: (
            <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1250_361)">
                    <mask
                        id="mask0_1250_361"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="26"
                        height="18"
                    >
                        <path
                            d="M22.8568 0H2.94247C1.64854 0 0.599609 1.04893 0.599609 2.34286V15.2286C0.599609 16.5225 1.64854 17.5714 2.94247 17.5714H22.8568C24.1507 17.5714 25.1996 16.5225 25.1996 15.2286V2.34286C25.1996 1.04893 24.1507 0 22.8568 0Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_1250_361)">
                        <path
                            d="M22.8568 0H2.94247C1.64854 0 0.599609 1.04893 0.599609 2.34286V15.2286C0.599609 16.5225 1.64854 17.5714 2.94247 17.5714H22.8568C24.1507 17.5714 25.1996 16.5225 25.1996 15.2286V2.34286C25.1996 1.04893 24.1507 0 22.8568 0Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.599609 0H6.45675V17.5714H0.599609V0ZM19.3425 0H25.1996V17.5714H19.3425V0ZM12.8996 4.68571L11.7282 7.02857L9.97104 5.85714V8.2L8.79961 9.37143L11.1425 10.5429H12.3139V12.8857H13.4853V10.5429H14.6568L16.9996 9.37143L15.8282 8.2V5.85714L13.9539 7.02857L12.8996 4.68571Z"
                            fill="#FF0000"
                        />
                        <path
                            d="M22.8567 0.585938H2.94246C1.97202 0.585938 1.18532 1.37264 1.18532 2.34308V15.2288C1.18532 16.1992 1.97202 16.9859 2.94246 16.9859H22.8567C23.8272 16.9859 24.6139 16.1992 24.6139 15.2288V2.34308C24.6139 1.37264 23.8272 0.585938 22.8567 0.585938Z"
                            stroke="black"
                            strokeOpacity="0.1"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_1250_361">
                        <rect width="24.6" height="17.5714" fill="white" transform="translate(0.599609)" />
                    </clipPath>
                </defs>
            </svg>
        ),
        flagUs: (
            <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1250_1711)">
                    <mask
                        id="mask0_1250_1711"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="25"
                        height="18"
                    >
                        <path
                            d="M22.2571 0H2.34286C1.04893 0 0 1.04893 0 2.34286V15.2286C0 16.5225 1.04893 17.5714 2.34286 17.5714H22.2571C23.5511 17.5714 24.6 16.5225 24.6 15.2286V2.34286C24.6 1.04893 23.5511 0 22.2571 0Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_1250_1711)">
                        <path
                            d="M22.2571 0H2.34286C1.04893 0 0 1.04893 0 2.34286V15.2286C0 16.5225 1.04893 17.5714 2.34286 17.5714H22.2571C23.5511 17.5714 24.6 16.5225 24.6 15.2286V2.34286C24.6 1.04893 23.5511 0 22.2571 0Z"
                            fill="white"
                        />
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 0H10.5429V8.2H0V0Z" fill="#444379" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1.17145 1.17139V2.34282H2.34288V1.17139H1.17145ZM3.5143 1.17139V2.34282H4.68573V1.17139H3.5143ZM5.85716 1.17139V2.34282H7.02859V1.17139H5.85716ZM8.20002 1.17139V2.34282H9.37145V1.17139H8.20002ZM7.02859 2.34282V3.51424H8.20002V2.34282H7.02859ZM4.68573 2.34282V3.51424H5.85716V2.34282H4.68573ZM2.34288 2.34282V3.51424H3.5143V2.34282H2.34288ZM1.17145 3.51424V4.68567H2.34288V3.51424H1.17145ZM3.5143 3.51424V4.68567H4.68573V3.51424H3.5143ZM5.85716 3.51424V4.68567H7.02859V3.51424H5.85716ZM8.20002 3.51424V4.68567H9.37145V3.51424H8.20002ZM1.17145 5.8571V7.02853H2.34288V5.8571H1.17145ZM3.5143 5.8571V7.02853H4.68573V5.8571H3.5143ZM5.85716 5.8571V7.02853H7.02859V5.8571H5.85716ZM8.20002 5.8571V7.02853H9.37145V5.8571H8.20002ZM7.02859 4.68567V5.8571H8.20002V4.68567H7.02859ZM4.68573 4.68567V5.8571H5.85716V4.68567H4.68573ZM2.34288 4.68567V5.8571H3.5143V4.68567H2.34288Z"
                            fill="#A7B6E7"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5429 0V1.17143H24.6V0H10.5429ZM10.5429 2.34286V3.51429H24.6V2.34286H10.5429ZM10.5429 4.68571V5.85714H24.6V4.68571H10.5429ZM10.5429 7.02857V8.2H24.6V7.02857H10.5429ZM0 9.37143V10.5429H24.6V9.37143H0ZM0 11.7143V12.8857H24.6V11.7143H0ZM0 14.0571V15.2286H24.6V14.0571H0ZM0 16.4V17.5714H24.6V16.4H0Z"
                            fill="#ED4C49"
                        />
                        <path
                            d="M22.2571 0.585938H2.34284C1.37239 0.585938 0.585693 1.37264 0.585693 2.34308V15.2288C0.585693 16.1992 1.37239 16.9859 2.34284 16.9859H22.2571C23.2276 16.9859 24.0143 16.1992 24.0143 15.2288V2.34308C24.0143 1.37264 23.2276 0.585938 22.2571 0.585938Z"
                            stroke="black"
                            strokeOpacity="0.1"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_1250_1711">
                        <rect width="24.6" height="17.5714" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        ),
        flagFr: (
            <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1250_611)">
                    <mask
                        id="mask0_1250_611"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="25"
                        height="18"
                    >
                        <path
                            d="M22.4573 0H2.54305C1.24913 0 0.200195 1.04893 0.200195 2.34286V15.2286C0.200195 16.5225 1.24913 17.5714 2.54305 17.5714H22.4573C23.7513 17.5714 24.8002 16.5225 24.8002 15.2286V2.34286C24.8002 1.04893 23.7513 0 22.4573 0Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_1250_611)">
                        <path
                            d="M22.4573 0H2.54305C1.24913 0 0.200195 1.04893 0.200195 2.34286V15.2286C0.200195 16.5225 1.24913 17.5714 2.54305 17.5714H22.4573C23.7513 17.5714 24.8002 16.5225 24.8002 15.2286V2.34286C24.8002 1.04893 23.7513 0 22.4573 0Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.200195 0H8.4002V17.5714H0.200195V0Z"
                            fill="#001C98"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.6002 0H24.8002V17.5714H16.6002V0Z"
                            fill="#F02532"
                        />
                        <path
                            d="M22.4573 0.585938H2.54305C1.5726 0.585938 0.785904 1.37264 0.785904 2.34308V15.2288C0.785904 16.1992 1.5726 16.9859 2.54305 16.9859H22.4573C23.4278 16.9859 24.2145 16.1992 24.2145 15.2288V2.34308C24.2145 1.37264 23.4278 0.585938 22.4573 0.585938Z"
                            stroke="black"
                            strokeOpacity="0.1"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_1250_611">
                        <rect width="24.6" height="17.5714" fill="white" transform="translate(0.200195)" />
                    </clipPath>
                </defs>
            </svg>
        ),
        address: (
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.5 3L16.5 21M3.5 17L12.5 12M8.3 21H16.7C18.3802 21 19.2202 21 19.862 20.673C20.4265 20.3854 20.8854 19.9265 21.173 19.362C21.5 18.7202 21.5 17.8802 21.5 16.2V7.8C21.5 6.11984 21.5 5.27976 21.173 4.63803C20.8854 4.07354 20.4265 3.6146 19.862 3.32698C19.2202 3 18.3802 3 16.7 3H8.3C6.61984 3 5.77976 3 5.13803 3.32698C4.57354 3.6146 4.1146 4.07354 3.82698 4.63803C3.5 5.27976 3.5 6.11984 3.5 7.8V16.2C3.5 17.8802 3.5 18.7202 3.82698 19.362C4.1146 19.9265 4.57354 20.3854 5.13803 20.673C5.77976 21 6.61984 21 8.3 21Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        eyeOff: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        map1: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M9 18L2 22V6L9 2M9 18L16 22M9 18V2M16 22L22 18V2L16 6M16 22V6M16 6L9 2"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        coinsHand: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    d="M13.5295 8.35186C12.9571 8.75995 12.2566 9 11.5 9C9.567 9 8 7.433 8 5.5C8 3.567 9.567 2 11.5 2C12.753 2 13.8522 2.65842 14.4705 3.64814M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2086L12.3769 20.8789C12.9753 21.0247 13.5988 21.0388 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7854 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4134 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2091C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1417C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M20 6.5C20 8.433 18.433 10 16.5 10C14.567 10 13 8.433 13 6.5C13 4.567 14.567 3 16.5 3C18.433 3 20 4.567 20 6.5ZM2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7951 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.0399 6 13.7599 5.89101 13.546C5.79513 13.3578 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13L3.6 13C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3578 2.10899 13.546C2 13.7599 2 14.0399 2 14.6Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        threeDotsHorizontal: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        dotsVertical: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        filePlus: (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                    d="M14.5 2.26953V6.40007C14.5 6.96012 14.5 7.24015 14.609 7.45406C14.7049 7.64222 14.8578 7.7952 15.046 7.89108C15.2599 8.00007 15.5399 8.00007 16.1 8.00007H20.2305M12.5 18V12M9.5 15H15.5M14.5 2H9.3C7.61984 2 6.77976 2 6.13803 2.32698C5.57354 2.6146 5.1146 3.07354 4.82698 3.63803C4.5 4.27976 4.5 5.11984 4.5 6.8V17.2C4.5 18.8802 4.5 19.7202 4.82698 20.362C5.1146 20.9265 5.57354 21.3854 6.13803 21.673C6.77976 22 7.61984 22 9.3 22H15.7C17.3802 22 18.2202 22 18.862 21.673C19.4265 21.3854 19.8854 20.9265 20.173 20.362C20.5 19.7202 20.5 18.8802 20.5 17.2V8L14.5 2Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        play: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                className={className}
            >
                <path
                    d="M8.3335 8.31606C8.3335 6.69745 8.3335 5.88815 8.67098 5.44203C8.96499 5.05338 9.41437 4.81288 9.90083 4.78383C10.4592 4.75049 11.1326 5.19941 12.4794 6.09726L30.0053 17.7812C31.1181 18.5231 31.6745 18.894 31.8684 19.3616C32.0379 19.7703 32.0379 20.2297 31.8684 20.6385C31.6745 21.106 31.1181 21.4769 30.0053 22.2188L12.4794 33.9028C11.1326 34.8006 10.4592 35.2495 9.90083 35.2162C9.41437 35.1871 8.96499 34.9466 8.67098 34.558C8.3335 34.1119 8.3335 33.3026 8.3335 31.684V8.31606Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        frame: (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path
                    d="M8.83317 4.99996H12.8332C13.7666 4.99996 14.2333 4.99996 14.5898 5.18161C14.9034 5.3414 15.1584 5.59637 15.3182 5.90997C15.4998 6.26649 15.4998 6.7332 15.4998 7.66662V11.6666M2.1665 4.99996H5.49984M15.4998 15V18.3333M18.8332 15L8.1665 15C7.23308 15 6.76637 15 6.40985 14.8183C6.09625 14.6585 5.84128 14.4035 5.68149 14.0899C5.49984 13.7334 5.49984 13.2667 5.49984 12.3333V1.66663"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        disconnect: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        mail: (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                    d="M2.5 7L10.6649 12.7154C11.3261 13.1783 11.6567 13.4097 12.0163 13.4993C12.3339 13.5785 12.6661 13.5785 12.9837 13.4993C13.3433 13.4097 13.6739 13.1783 14.3351 12.7154L22.5 7M7.3 20H17.7C19.3802 20 20.2202 20 20.862 19.673C21.4265 19.3854 21.8854 18.9265 22.173 18.362C22.5 17.7202 22.5 16.8802 22.5 15.2V8.8C22.5 7.11984 22.5 6.27976 22.173 5.63803C21.8854 5.07354 21.4265 4.6146 20.862 4.32698C20.2202 4 19.3802 4 17.7 4H7.3C5.61984 4 4.77976 4 4.13803 4.32698C3.57354 4.6146 3.1146 5.07354 2.82698 5.63803C2.5 6.27976 2.5 7.11984 2.5 8.8V15.2C2.5 16.8802 2.5 17.7202 2.82698 18.362C3.1146 18.9265 3.57354 19.3854 4.13803 19.673C4.77976 20 5.61984 20 7.3 20Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        cornerUpLeft: (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                    d="M9.5 14L4.5 9M4.5 9L9.5 4M4.5 9H10.9C14.2603 9 15.9405 9 17.2239 9.65396C18.3529 10.2292 19.2708 11.1471 19.846 12.2761C20.5 13.5595 20.5 15.2397 20.5 18.6V20"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        cornerUpRight: (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                    d="M4.5 20V18.6C4.5 15.2397 4.5 13.5595 5.15396 12.2761C5.7292 11.1471 6.64708 10.2292 7.77606 9.65396C9.05953 9 10.7397 9 14.1 9H20.5M20.5 9L15.5 14M20.5 9L15.5 4"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        star: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M11.2827 3.45307C11.5131 2.98613 11.6284 2.75266 11.7848 2.67807C11.9209 2.61317 12.0791 2.61317 12.2152 2.67807C12.3717 2.75266 12.4869 2.98613 12.7174 3.45307L14.9041 7.88304C14.9721 8.02089 15.0061 8.08982 15.0558 8.14333C15.0999 8.19071 15.1527 8.22911 15.2113 8.25638C15.2776 8.28718 15.3536 8.2983 15.5057 8.32053L20.397 9.03546C20.9121 9.11075 21.1696 9.14839 21.2888 9.27419C21.3925 9.38365 21.4412 9.53405 21.4215 9.68353C21.3988 9.85533 21.2124 10.0369 20.8395 10.4001L17.3014 13.8462C17.1912 13.9536 17.136 14.0073 17.1004 14.0712C17.0689 14.1278 17.0487 14.19 17.0409 14.2543C17.0321 14.3269 17.0451 14.4027 17.0711 14.5545L17.906 19.4219C17.994 19.9352 18.038 20.1919 17.9553 20.3443C17.8833 20.4768 17.7554 20.5697 17.6071 20.5972C17.4366 20.6288 17.2061 20.5076 16.7451 20.2652L12.3724 17.9656C12.2361 17.8939 12.168 17.8581 12.0962 17.844C12.0327 17.8316 11.9673 17.8316 11.9038 17.844C11.832 17.8581 11.7639 17.8939 11.6277 17.9656L7.25492 20.2652C6.79392 20.5076 6.56341 20.6288 6.39297 20.5972C6.24468 20.5697 6.11672 20.4768 6.04474 20.3443C5.962 20.1919 6.00603 19.9352 6.09407 19.4219L6.92889 14.5545C6.95491 14.4027 6.96793 14.3269 6.95912 14.2543C6.95132 14.19 6.93111 14.1278 6.89961 14.0712C6.86402 14.0073 6.80888 13.9536 6.69859 13.8462L3.16056 10.4001C2.78766 10.0369 2.60121 9.85533 2.57853 9.68353C2.55879 9.53405 2.60755 9.38365 2.71125 9.27419C2.83044 9.14839 3.08797 9.11075 3.60304 9.03546L8.49431 8.32053C8.64642 8.2983 8.72248 8.28718 8.78872 8.25638C8.84736 8.22911 8.90016 8.19071 8.94419 8.14333C8.99391 8.08982 9.02793 8.02089 9.09597 7.88304L11.2827 3.45307Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        starFilled: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        starHalfFilled: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9V6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        starOutlineFilled: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9L8.24 18.17L9.24 13.89L5.92 11.01L10.3 10.63L12 6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z"
                    fill="currentColor"
                    fillOpacity="0.24"
                />
            </SvgIcon>
        ),
        emoji: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        close: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        successHand: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                sx={{ fill: "none", ...sx }}
            >
                <path
                    d="M11.5425 40.2957V19.2331M1.68945 23.0626V36.4661C1.68945 38.5811 3.454 40.2957 5.63067 40.2957H32.0885C35.0064 40.2957 37.4879 38.2271 37.9316 35.4248L40.0538 22.0213C40.6048 18.5416 37.834 15.4035 34.2107 15.4035H27.3074C26.219 15.4035 25.3368 14.5462 25.3368 13.4887V6.72155C25.3368 4.11391 23.1612 2 20.4775 2C19.8374 2 19.2574 2.36629 18.9974 2.93465L12.0626 18.0959C11.7463 18.7874 11.0406 19.2331 10.2618 19.2331H5.63067C3.454 19.2331 1.68945 20.9476 1.68945 23.0626Z"
                    stroke="#03CC6C"
                    strokeWidth="2.87218"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        warningHand: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                className={className}
            >
                <path
                    d="M30.4585 1.99998L30.4585 23.0626M40.3115 19.233L40.3115 5.82955C40.3115 3.71454 38.547 1.99998 36.3703 1.99998L9.91244 1.99998C6.99454 1.99998 4.51305 4.06858 4.06936 6.87086L1.94717 20.2743C1.39622 23.754 4.16698 26.8922 7.79025 26.8922L14.6936 26.8922C15.782 26.8922 16.6642 27.7494 16.6642 28.807L16.6642 35.5741C16.6642 38.1817 18.8398 40.2957 21.5234 40.2957C22.1635 40.2957 22.7436 39.9294 23.0036 39.361L29.9384 24.1997C30.2546 23.5082 30.9604 23.0626 31.7391 23.0626L36.3703 23.0626C38.547 23.0626 40.3115 21.348 40.3115 19.233Z"
                    stroke="currentColor"
                    strokeWidth="2.87218"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        upload: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        trash: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <path
                    d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
                    stroke={color || "currentColor"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        cancel: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        userSvg: (
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 19C17 17.6044 17 16.9067 16.8278 16.3389C16.44 15.0605 15.4395 14.06 14.1611 13.6722C13.5933 13.5 12.8956 13.5 11.5 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        barChart: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
            >
                <path
                    d="M4.5 14.6667L4.5 28M20.5 14.6667L20.5 28M12.5 4L12.5 28M28.5 4V28"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        campaignSent: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
            >
                <path
                    d="M21.666 13L21.666 8.8C21.666 7.11984 21.666 6.27976 21.339 5.63803C21.0514 5.07354 20.5925 4.6146 20.028 4.32698C19.3863 4 18.5462 4 16.866 4L9.46602 4C7.78586 4 6.94578 4 6.30405 4.32698C5.73956 4.6146 5.28062 5.07354 4.993 5.63803C4.66602 6.27976 4.66602 7.11984 4.66602 8.8L4.66602 16.2C4.66602 17.8802 4.66602 18.7202 4.993 19.362C5.28062 19.9265 5.73956 20.3854 6.30405 20.673C6.94578 21 7.78586 21 9.46602 21L12.166 21M15.666 19L17.666 21L21.666 17M15.4665 13L9.4665 13M17.4665 9L9.4665 9"
                    stroke="#377BFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        campaignOpened: (
            <SvgIcon
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                sx={{ fill: "none", ...sx }}
            >
                <path
                    d="M8 2.5V1M4.06066 4.06066L3 3M4.06066 12L3 13.0607M12 4.06066L13.0607 3M2.5 8H1M7.5 7.5L11.6111 20.2778L14.5 17.3889L18.1111 21L21 18.1111L17.3889 14.5L20.2778 11.6111L7.5 7.5Z"
                    stroke="#00D863"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        greyFacebook: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                sx={{ fill: "none", ...sx }}
            >
                <g opacity="0.4">
                    <rect y="0.5" width="24" height="24" rx="12" fill="#68738D" fill-opacity="0.64" />
                    <path
                        d="M14.8077 13.2496L15.1497 11.0789H13.0433V9.66789C13.0433 9.07434 13.3374 8.49435 14.2777 8.49435H15.2489V6.64585C14.6833 6.55574 14.1119 6.50699 13.5391 6.5C11.8054 6.5 10.6735 7.54127 10.6735 9.42369V11.0789H8.75177V13.2496H10.6735V18.5H13.0433V13.2496H14.8077Z"
                        fill="white"
                    />
                </g>
            </SvgIcon>
        ),
        greyInstagram: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                sx={{ fill: "none", ...sx }}
            >
                <g opacity="0.4">
                    <rect y="0.5" width="24" height="24" rx="12" fill="#68738D" fill-opacity="0.64" />
                    <path
                        d="M9.89162 12.5725C9.89162 11.3662 10.8699 10.388 12.0769 10.388C13.2839 10.388 14.2627 11.3662 14.2627 12.5725C14.2627 13.7788 13.2839 14.757 12.0769 14.757C10.8699 14.757 9.89162 13.7788 9.89162 12.5725ZM8.71002 12.5725C8.71002 14.4309 10.2174 15.9373 12.0769 15.9373C13.9364 15.9373 15.4438 14.4309 15.4438 12.5725C15.4438 10.7141 13.9364 9.20762 12.0769 9.20762C10.2174 9.20762 8.71002 10.7141 8.71002 12.5725ZM14.7902 9.0742C14.7902 9.22973 14.8363 9.38178 14.9227 9.51113C15.0091 9.64048 15.1319 9.74132 15.2757 9.80089C15.4194 9.86047 15.5776 9.8761 15.7303 9.84582C15.8829 9.81554 16.0231 9.7407 16.1332 9.63077C16.2433 9.52085 16.3183 9.38076 16.3487 9.22824C16.3791 9.07571 16.3636 8.91759 16.3041 8.77388C16.2446 8.63017 16.1438 8.50732 16.0145 8.42086C15.8851 8.3344 15.733 8.28822 15.5774 8.28816H15.5771C15.3685 8.28826 15.1684 8.3711 15.0209 8.51848C14.8734 8.66586 14.7904 8.86573 14.7902 9.0742ZM9.42792 17.9064C8.78865 17.8773 8.44119 17.7709 8.21028 17.681C7.90415 17.5619 7.68573 17.42 7.45608 17.1908C7.22644 16.9616 7.08428 16.7436 6.96563 16.4376C6.87562 16.207 6.76913 15.8596 6.74007 15.2207C6.70828 14.53 6.70194 14.3225 6.70194 12.5725C6.70194 10.8226 6.70881 10.6157 6.74007 9.92436C6.76918 9.28547 6.87645 8.93879 6.96563 8.70745C7.08481 8.4015 7.22675 8.18321 7.45608 7.9537C7.68542 7.72419 7.90363 7.58212 8.21028 7.46354C8.44108 7.37358 8.78865 7.26716 9.42792 7.23812C10.1191 7.20635 10.3267 7.20001 12.0769 7.20001C13.8271 7.20001 14.0349 7.20687 14.7267 7.23812C15.3659 7.26721 15.7128 7.37442 15.9443 7.46354C16.2504 7.58212 16.4689 7.7245 16.6985 7.9537C16.9282 8.1829 17.0698 8.4015 17.189 8.70745C17.279 8.93811 17.3855 9.28547 17.4145 9.92436C17.4463 10.6157 17.4527 10.8226 17.4527 12.5725C17.4527 14.3225 17.4463 14.5294 17.4145 15.2207C17.3854 15.8596 17.2784 16.2069 17.189 16.4376C17.0698 16.7436 16.9278 16.9619 16.6985 17.1908C16.4692 17.4198 16.2504 17.5619 15.9443 17.681C15.7135 17.771 15.3659 17.8774 14.7267 17.9064C14.0355 17.9382 13.8279 17.9445 12.0769 17.9445C10.3259 17.9445 10.1189 17.9382 9.42792 17.9064ZM9.37363 6.05922C8.67561 6.09098 8.19864 6.2016 7.78209 6.36359C7.3507 6.53087 6.98551 6.7553 6.62058 7.11943C6.25565 7.48357 6.03167 7.84912 5.86428 8.28025C5.7022 8.6968 5.59152 9.17323 5.55973 9.87083C5.52742 10.5695 5.52002 10.7929 5.52002 12.5725C5.52002 14.3521 5.52742 14.5754 5.55973 15.2741C5.59152 15.9718 5.7022 16.4482 5.86428 16.8647C6.03167 17.2956 6.2557 17.6616 6.62058 18.0255C6.98546 18.3895 7.3507 18.6136 7.78209 18.7814C8.19942 18.9434 8.67561 19.054 9.37363 19.0857C10.0731 19.1175 10.2963 19.1254 12.0769 19.1254C13.8575 19.1254 14.0811 19.118 14.7802 19.0857C15.4782 19.054 15.9549 18.9434 16.3717 18.7814C16.8028 18.6136 17.1683 18.3897 17.5332 18.0255C17.8982 17.6614 18.1217 17.2956 18.2895 16.8647C18.4516 16.4482 18.5628 15.9717 18.5941 15.2741C18.6259 14.5749 18.6333 14.3521 18.6333 12.5725C18.6333 10.7929 18.6259 10.5695 18.5941 9.87083C18.5623 9.17318 18.4516 8.69654 18.2895 8.28025C18.1217 7.84938 17.8976 7.48414 17.5332 7.11943C17.1689 6.75472 16.8028 6.53087 16.3722 6.36359C15.9549 6.2016 15.4782 6.09046 14.7807 6.05922C14.0816 6.02745 13.8581 6.01953 12.0774 6.01953C10.2968 6.01953 10.0731 6.02692 9.37363 6.05922Z"
                        fill="white"
                    />
                    <path
                        d="M9.89162 12.5725C9.89162 11.3662 10.8699 10.388 12.0769 10.388C13.2839 10.388 14.2627 11.3662 14.2627 12.5725C14.2627 13.7788 13.2839 14.757 12.0769 14.757C10.8699 14.757 9.89162 13.7788 9.89162 12.5725ZM8.71002 12.5725C8.71002 14.4309 10.2174 15.9373 12.0769 15.9373C13.9364 15.9373 15.4438 14.4309 15.4438 12.5725C15.4438 10.7141 13.9364 9.20762 12.0769 9.20762C10.2174 9.20762 8.71002 10.7141 8.71002 12.5725ZM14.7902 9.0742C14.7902 9.22973 14.8363 9.38178 14.9227 9.51113C15.0091 9.64048 15.1319 9.74132 15.2757 9.80089C15.4194 9.86047 15.5776 9.8761 15.7303 9.84582C15.8829 9.81554 16.0231 9.7407 16.1332 9.63077C16.2433 9.52085 16.3183 9.38076 16.3487 9.22824C16.3791 9.07571 16.3636 8.91759 16.3041 8.77388C16.2446 8.63017 16.1438 8.50732 16.0145 8.42086C15.8851 8.3344 15.733 8.28822 15.5774 8.28816H15.5771C15.3685 8.28826 15.1684 8.3711 15.0209 8.51848C14.8734 8.66586 14.7904 8.86573 14.7902 9.0742ZM9.42792 17.9064C8.78865 17.8773 8.44119 17.7709 8.21028 17.681C7.90415 17.5619 7.68573 17.42 7.45608 17.1908C7.22644 16.9616 7.08428 16.7436 6.96563 16.4376C6.87562 16.207 6.76913 15.8596 6.74007 15.2207C6.70828 14.53 6.70194 14.3225 6.70194 12.5725C6.70194 10.8226 6.70881 10.6157 6.74007 9.92436C6.76918 9.28547 6.87645 8.93879 6.96563 8.70745C7.08481 8.4015 7.22675 8.18321 7.45608 7.9537C7.68542 7.72419 7.90363 7.58212 8.21028 7.46354C8.44108 7.37358 8.78865 7.26716 9.42792 7.23812C10.1191 7.20635 10.3267 7.20001 12.0769 7.20001C13.8271 7.20001 14.0349 7.20687 14.7267 7.23812C15.3659 7.26721 15.7128 7.37442 15.9443 7.46354C16.2504 7.58212 16.4689 7.7245 16.6985 7.9537C16.9282 8.1829 17.0698 8.4015 17.189 8.70745C17.279 8.93811 17.3855 9.28547 17.4145 9.92436C17.4463 10.6157 17.4527 10.8226 17.4527 12.5725C17.4527 14.3225 17.4463 14.5294 17.4145 15.2207C17.3854 15.8596 17.2784 16.2069 17.189 16.4376C17.0698 16.7436 16.9278 16.9619 16.6985 17.1908C16.4692 17.4198 16.2504 17.5619 15.9443 17.681C15.7135 17.771 15.3659 17.8774 14.7267 17.9064C14.0355 17.9382 13.8279 17.9445 12.0769 17.9445C10.3259 17.9445 10.1189 17.9382 9.42792 17.9064ZM9.37363 6.05922C8.67561 6.09098 8.19864 6.2016 7.78209 6.36359C7.3507 6.53087 6.98551 6.7553 6.62058 7.11943C6.25565 7.48357 6.03167 7.84912 5.86428 8.28025C5.7022 8.6968 5.59152 9.17323 5.55973 9.87083C5.52742 10.5695 5.52002 10.7929 5.52002 12.5725C5.52002 14.3521 5.52742 14.5754 5.55973 15.2741C5.59152 15.9718 5.7022 16.4482 5.86428 16.8647C6.03167 17.2956 6.2557 17.6616 6.62058 18.0255C6.98546 18.3895 7.3507 18.6136 7.78209 18.7814C8.19942 18.9434 8.67561 19.054 9.37363 19.0857C10.0731 19.1175 10.2963 19.1254 12.0769 19.1254C13.8575 19.1254 14.0811 19.118 14.7802 19.0857C15.4782 19.054 15.9549 18.9434 16.3717 18.7814C16.8028 18.6136 17.1683 18.3897 17.5332 18.0255C17.8982 17.6614 18.1217 17.2956 18.2895 16.8647C18.4516 16.4482 18.5628 15.9717 18.5941 15.2741C18.6259 14.5749 18.6333 14.3521 18.6333 12.5725C18.6333 10.7929 18.6259 10.5695 18.5941 9.87083C18.5623 9.17318 18.4516 8.69654 18.2895 8.28025C18.1217 7.84938 17.8976 7.48414 17.5332 7.11943C17.1689 6.75472 16.8028 6.53087 16.3722 6.36359C15.9549 6.2016 15.4782 6.09046 14.7807 6.05922C14.0816 6.02745 13.8581 6.01953 12.0774 6.01953C10.2968 6.01953 10.0731 6.02692 9.37363 6.05922Z"
                        fill="white"
                    />
                </g>
            </SvgIcon>
        ),
        greyGoogle: (
            <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                sx={{ fill: "none", ...sx }}
            >
                <g opacity="0.4">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M21.2398 11.7414C21.2398 10.985 21.1718 10.2578 21.0459 9.55957H10.9998V13.6856H16.7403C16.4931 15.0189 15.7416 16.1486 14.6118 16.905V19.5814H18.0592C20.0761 17.7245 21.2398 14.9899 21.2398 11.7414Z"
                        fill="#68738D"
                        fill-opacity="0.64"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.9994 22.1664C13.8795 22.1664 16.2939 21.2112 18.0588 19.5821L14.6115 16.9057C13.6564 17.5457 12.4346 17.9239 10.9994 17.9239C8.22123 17.9239 5.86971 16.0475 5.03092 13.5264H1.46729V16.29C3.22244 19.776 6.82971 22.1664 10.9994 22.1664Z"
                        fill="#68738D"
                        fill-opacity="0.64"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.03094 13.5259C4.81761 12.8859 4.6964 12.2023 4.6964 11.4993C4.6964 10.7962 4.81761 10.1126 5.03094 9.47262V6.70898H1.46731C0.744885 8.14898 0.332764 9.77807 0.332764 11.4993C0.332764 13.2205 0.744885 14.8495 1.46731 16.2895L5.03094 13.5259Z"
                        fill="#68738D"
                        fill-opacity="0.64"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.9994 5.07544C12.5654 5.07544 13.9715 5.61362 15.077 6.67058L18.1364 3.61119C16.2891 1.88998 13.8746 0.833008 10.9994 0.833008C6.82971 0.833008 3.22244 3.22331 1.46729 6.70937L5.03092 9.47301C5.86971 6.9518 8.22123 5.07544 10.9994 5.07544Z"
                        fill="#68738D"
                        fill-opacity="0.64"
                    />
                </g>
            </SvgIcon>
        ),
        coloredFacebook: (
            <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="#337FFF" />
                <path
                    d="M14.8077 12.7496L15.1497 10.5789H13.0433V9.16789C13.0433 8.57434 13.3374 7.99435 14.2777 7.99435H15.2489V6.14585C14.6833 6.05574 14.1119 6.00699 13.5391 6C11.8054 6 10.6735 7.04127 10.6735 8.92369V10.5789H8.75177V12.7496H10.6735V18H13.0433V12.7496H14.8077Z"
                    fill="white"
                />
            </SvgIcon>
        ),
        coloredInstagram: (
            <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="url(#paint0_linear_18549_127238)" />
                <path
                    d="M9.89162 12.0725C9.89162 10.8662 10.8699 9.88799 12.0769 9.88799C13.2839 9.88799 14.2627 10.8662 14.2627 12.0725C14.2627 13.2788 13.2839 14.257 12.0769 14.257C10.8699 14.257 9.89162 13.2788 9.89162 12.0725ZM8.71002 12.0725C8.71002 13.9309 10.2174 15.4373 12.0769 15.4373C13.9364 15.4373 15.4438 13.9309 15.4438 12.0725C15.4438 10.2141 13.9364 8.70762 12.0769 8.70762C10.2174 8.70762 8.71002 10.2141 8.71002 12.0725ZM14.7902 8.5742C14.7902 8.72973 14.8363 8.88178 14.9227 9.01113C15.0091 9.14048 15.1319 9.24132 15.2757 9.30089C15.4194 9.36047 15.5776 9.3761 15.7303 9.34582C15.8829 9.31554 16.0231 9.2407 16.1332 9.13077C16.2433 9.02085 16.3183 8.88076 16.3487 8.72824C16.3791 8.57571 16.3636 8.41759 16.3041 8.27388C16.2446 8.13017 16.1438 8.00732 16.0145 7.92086C15.8851 7.8344 15.733 7.78822 15.5774 7.78816H15.5771C15.3685 7.78826 15.1684 7.8711 15.0209 8.01848C14.8734 8.16586 14.7904 8.36573 14.7902 8.5742ZM9.42792 17.4064C8.78865 17.3773 8.44119 17.2709 8.21028 17.181C7.90415 17.0619 7.68573 16.92 7.45608 16.6908C7.22644 16.4616 7.08428 16.2436 6.96563 15.9376C6.87562 15.707 6.76913 15.3596 6.74007 14.7207C6.70828 14.03 6.70194 13.8225 6.70194 12.0725C6.70194 10.3226 6.70881 10.1157 6.74007 9.42436C6.76918 8.78547 6.87645 8.43879 6.96563 8.20745C7.08481 7.9015 7.22675 7.68321 7.45608 7.4537C7.68542 7.22419 7.90363 7.08212 8.21028 6.96354C8.44108 6.87358 8.78865 6.76716 9.42792 6.73812C10.1191 6.70635 10.3267 6.70001 12.0769 6.70001C13.8271 6.70001 14.0349 6.70687 14.7267 6.73812C15.3659 6.76721 15.7128 6.87442 15.9443 6.96354C16.2504 7.08212 16.4689 7.2245 16.6985 7.4537C16.9282 7.6829 17.0698 7.9015 17.189 8.20745C17.279 8.43811 17.3855 8.78547 17.4145 9.42436C17.4463 10.1157 17.4527 10.3226 17.4527 12.0725C17.4527 13.8225 17.4463 14.0294 17.4145 14.7207C17.3854 15.3596 17.2784 15.7069 17.189 15.9376C17.0698 16.2436 16.9278 16.4619 16.6985 16.6908C16.4692 16.9198 16.2504 17.0619 15.9443 17.181C15.7135 17.271 15.3659 17.3774 14.7267 17.4064C14.0355 17.4382 13.8279 17.4445 12.0769 17.4445C10.3259 17.4445 10.1189 17.4382 9.42792 17.4064ZM9.37363 5.55922C8.67561 5.59098 8.19864 5.7016 7.78209 5.86359C7.3507 6.03087 6.98551 6.2553 6.62058 6.61943C6.25565 6.98357 6.03167 7.34912 5.86428 7.78025C5.7022 8.1968 5.59152 8.67323 5.55973 9.37083C5.52742 10.0695 5.52002 10.2929 5.52002 12.0725C5.52002 13.8521 5.52742 14.0754 5.55973 14.7741C5.59152 15.4718 5.7022 15.9482 5.86428 16.3647C6.03167 16.7956 6.2557 17.1616 6.62058 17.5255C6.98546 17.8895 7.3507 18.1136 7.78209 18.2814C8.19942 18.4434 8.67561 18.554 9.37363 18.5857C10.0731 18.6175 10.2963 18.6254 12.0769 18.6254C13.8575 18.6254 14.0811 18.618 14.7802 18.5857C15.4782 18.554 15.9549 18.4434 16.3717 18.2814C16.8028 18.1136 17.1683 17.8897 17.5332 17.5255C17.8982 17.1614 18.1217 16.7956 18.2895 16.3647C18.4516 15.9482 18.5628 15.4717 18.5941 14.7741C18.6259 14.0749 18.6333 13.8521 18.6333 12.0725C18.6333 10.2929 18.6259 10.0695 18.5941 9.37083C18.5623 8.67318 18.4516 8.19654 18.2895 7.78025C18.1217 7.34938 17.8976 6.98414 17.5332 6.61943C17.1689 6.25472 16.8028 6.03087 16.3722 5.86359C15.9549 5.7016 15.4782 5.59046 14.7807 5.55922C14.0816 5.52745 13.8581 5.51953 12.0774 5.51953C10.2968 5.51953 10.0731 5.52692 9.37363 5.55922Z"
                    fill="white"
                />
                <path
                    d="M9.89162 12.0725C9.89162 10.8662 10.8699 9.88799 12.0769 9.88799C13.2839 9.88799 14.2627 10.8662 14.2627 12.0725C14.2627 13.2788 13.2839 14.257 12.0769 14.257C10.8699 14.257 9.89162 13.2788 9.89162 12.0725ZM8.71002 12.0725C8.71002 13.9309 10.2174 15.4373 12.0769 15.4373C13.9364 15.4373 15.4438 13.9309 15.4438 12.0725C15.4438 10.2141 13.9364 8.70762 12.0769 8.70762C10.2174 8.70762 8.71002 10.2141 8.71002 12.0725ZM14.7902 8.5742C14.7902 8.72973 14.8363 8.88178 14.9227 9.01113C15.0091 9.14048 15.1319 9.24132 15.2757 9.30089C15.4194 9.36047 15.5776 9.3761 15.7303 9.34582C15.8829 9.31554 16.0231 9.2407 16.1332 9.13077C16.2433 9.02085 16.3183 8.88076 16.3487 8.72824C16.3791 8.57571 16.3636 8.41759 16.3041 8.27388C16.2446 8.13017 16.1438 8.00732 16.0145 7.92086C15.8851 7.8344 15.733 7.78822 15.5774 7.78816H15.5771C15.3685 7.78826 15.1684 7.8711 15.0209 8.01848C14.8734 8.16586 14.7904 8.36573 14.7902 8.5742ZM9.42792 17.4064C8.78865 17.3773 8.44119 17.2709 8.21028 17.181C7.90415 17.0619 7.68573 16.92 7.45608 16.6908C7.22644 16.4616 7.08428 16.2436 6.96563 15.9376C6.87562 15.707 6.76913 15.3596 6.74007 14.7207C6.70828 14.03 6.70194 13.8225 6.70194 12.0725C6.70194 10.3226 6.70881 10.1157 6.74007 9.42436C6.76918 8.78547 6.87645 8.43879 6.96563 8.20745C7.08481 7.9015 7.22675 7.68321 7.45608 7.4537C7.68542 7.22419 7.90363 7.08212 8.21028 6.96354C8.44108 6.87358 8.78865 6.76716 9.42792 6.73812C10.1191 6.70635 10.3267 6.70001 12.0769 6.70001C13.8271 6.70001 14.0349 6.70687 14.7267 6.73812C15.3659 6.76721 15.7128 6.87442 15.9443 6.96354C16.2504 7.08212 16.4689 7.2245 16.6985 7.4537C16.9282 7.6829 17.0698 7.9015 17.189 8.20745C17.279 8.43811 17.3855 8.78547 17.4145 9.42436C17.4463 10.1157 17.4527 10.3226 17.4527 12.0725C17.4527 13.8225 17.4463 14.0294 17.4145 14.7207C17.3854 15.3596 17.2784 15.7069 17.189 15.9376C17.0698 16.2436 16.9278 16.4619 16.6985 16.6908C16.4692 16.9198 16.2504 17.0619 15.9443 17.181C15.7135 17.271 15.3659 17.3774 14.7267 17.4064C14.0355 17.4382 13.8279 17.4445 12.0769 17.4445C10.3259 17.4445 10.1189 17.4382 9.42792 17.4064ZM9.37363 5.55922C8.67561 5.59098 8.19864 5.7016 7.78209 5.86359C7.3507 6.03087 6.98551 6.2553 6.62058 6.61943C6.25565 6.98357 6.03167 7.34912 5.86428 7.78025C5.7022 8.1968 5.59152 8.67323 5.55973 9.37083C5.52742 10.0695 5.52002 10.2929 5.52002 12.0725C5.52002 13.8521 5.52742 14.0754 5.55973 14.7741C5.59152 15.4718 5.7022 15.9482 5.86428 16.3647C6.03167 16.7956 6.2557 17.1616 6.62058 17.5255C6.98546 17.8895 7.3507 18.1136 7.78209 18.2814C8.19942 18.4434 8.67561 18.554 9.37363 18.5857C10.0731 18.6175 10.2963 18.6254 12.0769 18.6254C13.8575 18.6254 14.0811 18.618 14.7802 18.5857C15.4782 18.554 15.9549 18.4434 16.3717 18.2814C16.8028 18.1136 17.1683 17.8897 17.5332 17.5255C17.8982 17.1614 18.1217 16.7956 18.2895 16.3647C18.4516 15.9482 18.5628 15.4717 18.5941 14.7741C18.6259 14.0749 18.6333 13.8521 18.6333 12.0725C18.6333 10.2929 18.6259 10.0695 18.5941 9.37083C18.5623 8.67318 18.4516 8.19654 18.2895 7.78025C18.1217 7.34938 17.8976 6.98414 17.5332 6.61943C17.1689 6.25472 16.8028 6.03087 16.3722 5.86359C15.9549 5.7016 15.4782 5.59046 14.7807 5.55922C14.0816 5.52745 13.8581 5.51953 12.0774 5.51953C10.2968 5.51953 10.0731 5.52692 9.37363 5.55922Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_18549_127238"
                        x1="23.5387"
                        y1="24"
                        x2="-0.461279"
                        y2="-6.46012e-07"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#FBE18A" />
                        <stop offset="0.21" stop-color="#FCBB45" />
                        <stop offset="0.38" stop-color="#F75274" />
                        <stop offset="0.52" stop-color="#D53692" />
                        <stop offset="0.74" stop-color="#8F39CE" />
                        <stop offset="1" stop-color="#5B4FE9" />
                    </linearGradient>
                </defs>
            </SvgIcon>
        ),
        coloredGoogle: (
            <SvgIcon xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.24 11.2414C21.24 10.485 21.1721 9.75775 21.0461 9.05957H11V13.1856H16.7406C16.4933 14.5189 15.7418 15.6486 14.6121 16.405V19.0814H18.0594C20.0764 17.2245 21.24 14.4899 21.24 11.2414Z"
                    fill="#4285F4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9995 21.6664C13.8796 21.6664 16.294 20.7112 18.0589 19.0821L14.6117 16.4057C13.6565 17.0457 12.4347 17.4239 10.9995 17.4239C8.22135 17.4239 5.86984 15.5475 5.03104 13.0264H1.46741V15.79C3.22256 19.276 6.82984 21.6664 10.9995 21.6664Z"
                    fill="#34A853"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.03149 13.0259C4.81816 12.3859 4.69695 11.7023 4.69695 10.9993C4.69695 10.2962 4.81816 9.61262 5.03149 8.97262V6.20898H1.46786C0.745434 7.64898 0.333313 9.27807 0.333313 10.9993C0.333313 12.7205 0.745434 14.3495 1.46786 15.7895L5.03149 13.0259Z"
                    fill="#FBBC05"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9995 4.57544C12.5656 4.57544 13.9717 5.11362 15.0771 6.17058L18.1365 3.11119C16.2892 1.38998 13.8747 0.333008 10.9995 0.333008C6.82984 0.333008 3.22256 2.72331 1.46741 6.20937L5.03104 8.97301C5.86984 6.4518 8.22135 4.57544 10.9995 4.57544Z"
                    fill="#EA4335"
                />
            </SvgIcon>
        ),
        warning: (
            <SvgIcon width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" sx={sx}>
                <path
                    d="M11.0003 5.94949L17.9028 17.8753H4.09783L11.0003 5.94949ZM11.0003 2.29199L0.916992 19.7087H21.0837L11.0003 2.29199Z"
                    fill={fill || "#FFC431"}
                />
                <path d="M11.917 15.1253H10.0837V16.9587H11.917V15.1253Z" fill={fill || "#FFC431"} />
                <path d="M11.917 9.62533H10.0837V14.2087H11.917V9.62533Z" fill={fill || "#FFC431"} />
            </SvgIcon>
        ),
        social: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
            >
                <path
                    d="M7.15833 11.6581L12.85 14.9747M12.8417 5.82474L7.15833 9.14141M17.5 4.56641C17.5 5.94712 16.3807 7.06641 15 7.06641C13.6193 7.06641 12.5 5.94712 12.5 4.56641C12.5 3.18569 13.6193 2.06641 15 2.06641C16.3807 2.06641 17.5 3.18569 17.5 4.56641ZM7.5 10.3997C7.5 11.7805 6.38071 12.8997 5 12.8997C3.61929 12.8997 2.5 11.7805 2.5 10.3997C2.5 9.01903 3.61929 7.89974 5 7.89974C6.38071 7.89974 7.5 9.01903 7.5 10.3997ZM17.5 16.2331C17.5 17.6138 16.3807 18.7331 15 18.7331C13.6193 18.7331 12.5 17.6138 12.5 16.2331C12.5 14.8524 13.6193 13.7331 15 13.7331C16.3807 13.7331 17.5 14.8524 17.5 16.2331Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        facebookSocial: (
            <SvgIcon
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                data-testid="facebookSocial"
                xmlns="http://www.w3.org/2000/svg"
                sx={{ fill: "none", ...sx }}
            >
                <rect width="16" height="16" rx="8" fill="#337FFF" />
                <path
                    d="M9.87228 8.49972L10.1002 7.05257H8.69596V6.11193C8.69596 5.71622 8.89202 5.32956 9.51893 5.32956H10.1664V4.09723C9.78933 4.03716 9.40835 4.00466 9.02652 4C7.87072 4 7.11614 4.69418 7.11614 5.94912V7.05257H5.83496V8.49972H7.11614V12H8.69596V8.49972H9.87228Z"
                    fill="white"
                />
            </SvgIcon>
        ),
        instagramSocial: (
            <SvgIcon
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="none"
                data-testid="instagramSocial"
                xmlns="http://www.w3.org/2000/svg"
                sx={{ fill: "none", ...sx }}
            >
                <rect width="16" height="16" rx="8" fill="url(#paint0_linear_17287_61091)" />
                <path
                    d="M6.59409 8.04832C6.59409 7.24411 7.24625 6.59199 8.05094 6.59199C8.85564 6.59199 9.50814 7.24411 9.50814 8.04832C9.50814 8.85253 8.85564 9.50465 8.05094 9.50465C7.24625 9.50465 6.59409 8.85253 6.59409 8.04832ZM5.80636 8.04832C5.80636 9.28726 6.81125 10.2916 8.05094 10.2916C9.29063 10.2916 10.2955 9.28726 10.2955 8.04832C10.2955 6.80938 9.29063 5.80508 8.05094 5.80508C6.81125 5.80508 5.80636 6.80938 5.80636 8.04832ZM9.85984 5.71613C9.8598 5.81982 9.89052 5.92119 9.94812 6.00742C10.0057 6.09365 10.0876 6.16088 10.1835 6.20059C10.2793 6.24031 10.3848 6.25074 10.4865 6.23055C10.5883 6.21036 10.6818 6.16047 10.7552 6.08718C10.8285 6.0139 10.8785 5.92051 10.8988 5.81882C10.9191 5.71714 10.9088 5.61173 10.8691 5.51592C10.8294 5.42011 10.7622 5.33821 10.676 5.28057C10.5897 5.22294 10.4883 5.19215 10.3846 5.19211H10.3844C10.2453 5.19217 10.112 5.2474 10.0136 5.34565C9.91527 5.4439 9.85996 5.57715 9.85984 5.71613ZM6.28496 11.6043C5.85878 11.5849 5.62713 11.5139 5.4732 11.454C5.26911 11.3746 5.1235 11.28 4.9704 11.1272C4.8173 10.9744 4.72253 10.829 4.64343 10.6251C4.58342 10.4713 4.51243 10.2397 4.49306 9.81381C4.47186 9.35332 4.46763 9.21499 4.46763 8.04836C4.46763 6.88172 4.47221 6.74378 4.49306 6.2829C4.51246 5.85698 4.58398 5.62586 4.64343 5.47163C4.72288 5.26767 4.81751 5.12214 4.9704 4.96913C5.12329 4.81613 5.26876 4.72141 5.4732 4.64236C5.62706 4.58239 5.85878 4.51144 6.28496 4.49208C6.74572 4.4709 6.88413 4.46667 8.05094 4.46667C9.21775 4.46667 9.3563 4.47125 9.81745 4.49208C10.2436 4.51148 10.4749 4.58295 10.6292 4.64236C10.8333 4.72141 10.9789 4.81634 11.132 4.96913C11.2851 5.12193 11.3795 5.26767 11.459 5.47163C11.519 5.62541 11.59 5.85698 11.6094 6.2829C11.6305 6.74378 11.6348 6.88172 11.6348 8.04836C11.6348 9.21499 11.6305 9.35293 11.6094 9.81381C11.5899 10.2397 11.5186 10.4712 11.459 10.6251C11.3795 10.829 11.2849 10.9746 11.132 11.1272C10.9791 11.2799 10.8333 11.3746 10.6292 11.454C10.4753 11.514 10.2436 11.5849 9.81745 11.6043C9.35669 11.6255 9.21828 11.6297 8.05094 11.6297C6.88361 11.6297 6.74558 11.6255 6.28496 11.6043ZM6.24876 3.70614C5.78342 3.72732 5.46543 3.80107 5.18774 3.90906C4.90014 4.02058 4.65668 4.1702 4.41339 4.41295C4.17011 4.65571 4.02079 4.89941 3.9092 5.18683C3.80114 5.46454 3.72735 5.78215 3.70616 6.24722C3.68462 6.71302 3.67969 6.86194 3.67969 8.04832C3.67969 9.2347 3.68462 9.38362 3.70616 9.84942C3.72735 10.3145 3.80114 10.6321 3.9092 10.9098C4.02079 11.1971 4.17014 11.441 4.41339 11.6837C4.65665 11.9263 4.90014 12.0757 5.18774 12.1876C5.46596 12.2956 5.78342 12.3693 6.24876 12.3905C6.71509 12.4117 6.86385 12.417 8.05094 12.417C9.23804 12.417 9.38704 12.412 9.85312 12.3905C10.3185 12.3693 10.6363 12.2956 10.9141 12.1876C11.2016 12.0757 11.4452 11.9264 11.6885 11.6837C11.9318 11.4409 12.0808 11.1971 12.1927 10.9098C12.3007 10.6321 12.3749 10.3145 12.3957 9.84942C12.4169 9.38327 12.4218 9.2347 12.4218 8.04832C12.4218 6.86194 12.4169 6.71302 12.3957 6.24722C12.3745 5.78212 12.3007 5.46436 12.1927 5.18683C12.0808 4.89958 11.9314 4.65609 11.6885 4.41295C11.4456 4.16981 11.2016 4.02058 10.9145 3.90906C10.6363 3.80107 10.3185 3.72697 9.85347 3.70614C9.38739 3.68496 9.23839 3.67969 8.05129 3.67969C6.8642 3.67969 6.71509 3.68462 6.24876 3.70614Z"
                    fill="white"
                />
                <path
                    d="M6.59409 8.04832C6.59409 7.24411 7.24625 6.59199 8.05094 6.59199C8.85564 6.59199 9.50814 7.24411 9.50814 8.04832C9.50814 8.85253 8.85564 9.50465 8.05094 9.50465C7.24625 9.50465 6.59409 8.85253 6.59409 8.04832ZM5.80636 8.04832C5.80636 9.28726 6.81125 10.2916 8.05094 10.2916C9.29063 10.2916 10.2955 9.28726 10.2955 8.04832C10.2955 6.80938 9.29063 5.80508 8.05094 5.80508C6.81125 5.80508 5.80636 6.80938 5.80636 8.04832ZM9.85984 5.71613C9.8598 5.81982 9.89052 5.92119 9.94812 6.00742C10.0057 6.09365 10.0876 6.16088 10.1835 6.20059C10.2793 6.24031 10.3848 6.25074 10.4865 6.23055C10.5883 6.21036 10.6818 6.16047 10.7552 6.08718C10.8285 6.0139 10.8785 5.92051 10.8988 5.81882C10.9191 5.71714 10.9088 5.61173 10.8691 5.51592C10.8294 5.42011 10.7622 5.33821 10.676 5.28057C10.5897 5.22294 10.4883 5.19215 10.3846 5.19211H10.3844C10.2453 5.19217 10.112 5.2474 10.0136 5.34565C9.91527 5.4439 9.85996 5.57715 9.85984 5.71613ZM6.28496 11.6043C5.85878 11.5849 5.62713 11.5139 5.4732 11.454C5.26911 11.3746 5.1235 11.28 4.9704 11.1272C4.8173 10.9744 4.72253 10.829 4.64343 10.6251C4.58342 10.4713 4.51243 10.2397 4.49306 9.81381C4.47186 9.35332 4.46763 9.21499 4.46763 8.04836C4.46763 6.88172 4.47221 6.74378 4.49306 6.2829C4.51246 5.85698 4.58398 5.62586 4.64343 5.47163C4.72288 5.26767 4.81751 5.12214 4.9704 4.96913C5.12329 4.81613 5.26876 4.72141 5.4732 4.64236C5.62706 4.58239 5.85878 4.51144 6.28496 4.49208C6.74572 4.4709 6.88413 4.46667 8.05094 4.46667C9.21775 4.46667 9.3563 4.47125 9.81745 4.49208C10.2436 4.51148 10.4749 4.58295 10.6292 4.64236C10.8333 4.72141 10.9789 4.81634 11.132 4.96913C11.2851 5.12193 11.3795 5.26767 11.459 5.47163C11.519 5.62541 11.59 5.85698 11.6094 6.2829C11.6305 6.74378 11.6348 6.88172 11.6348 8.04836C11.6348 9.21499 11.6305 9.35293 11.6094 9.81381C11.5899 10.2397 11.5186 10.4712 11.459 10.6251C11.3795 10.829 11.2849 10.9746 11.132 11.1272C10.9791 11.2799 10.8333 11.3746 10.6292 11.454C10.4753 11.514 10.2436 11.5849 9.81745 11.6043C9.35669 11.6255 9.21828 11.6297 8.05094 11.6297C6.88361 11.6297 6.74558 11.6255 6.28496 11.6043ZM6.24876 3.70614C5.78342 3.72732 5.46543 3.80107 5.18774 3.90906C4.90014 4.02058 4.65668 4.1702 4.41339 4.41295C4.17011 4.65571 4.02079 4.89941 3.9092 5.18683C3.80114 5.46454 3.72735 5.78215 3.70616 6.24722C3.68462 6.71302 3.67969 6.86194 3.67969 8.04832C3.67969 9.2347 3.68462 9.38362 3.70616 9.84942C3.72735 10.3145 3.80114 10.6321 3.9092 10.9098C4.02079 11.1971 4.17014 11.441 4.41339 11.6837C4.65665 11.9263 4.90014 12.0757 5.18774 12.1876C5.46596 12.2956 5.78342 12.3693 6.24876 12.3905C6.71509 12.4117 6.86385 12.417 8.05094 12.417C9.23804 12.417 9.38704 12.412 9.85312 12.3905C10.3185 12.3693 10.6363 12.2956 10.9141 12.1876C11.2016 12.0757 11.4452 11.9264 11.6885 11.6837C11.9318 11.4409 12.0808 11.1971 12.1927 10.9098C12.3007 10.6321 12.3749 10.3145 12.3957 9.84942C12.4169 9.38327 12.4218 9.2347 12.4218 8.04832C12.4218 6.86194 12.4169 6.71302 12.3957 6.24722C12.3745 5.78212 12.3007 5.46436 12.1927 5.18683C12.0808 4.89958 11.9314 4.65609 11.6885 4.41295C11.4456 4.16981 11.2016 4.02058 10.9145 3.90906C10.6363 3.80107 10.3185 3.72697 9.85347 3.70614C9.38739 3.68496 9.23839 3.67969 8.05129 3.67969C6.8642 3.67969 6.71509 3.68462 6.24876 3.70614Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_17287_61091"
                        x1="15.6925"
                        y1="16"
                        x2="-0.30752"
                        y2="-4.30675e-07"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FBE18A" />
                        <stop offset="0.21" stopColor="#FCBB45" />
                        <stop offset="0.38" stopColor="#F75274" />
                        <stop offset="0.52" stopColor="#D53692" />
                        <stop offset="0.74" stopColor="#8F39CE" />
                        <stop offset="1" stopColor="#5B4FE9" />
                    </linearGradient>
                </defs>
            </SvgIcon>
        ),
        googleSocial: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                data-testid="googleSocial"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.8267 8.16158C14.8267 7.65734 14.7814 7.17249 14.6974 6.70703H8V9.4577H11.827C11.6622 10.3466 11.1612 11.0997 10.4081 11.604V13.3883H12.7063C14.0509 12.1503 14.8267 10.3272 14.8267 8.16158Z"
                    fill="#4285F4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99928 15.1116C9.91931 15.1116 11.529 14.4748 12.7055 13.3887L10.4074 11.6044C9.77061 12.0311 8.95607 12.2832 7.99928 12.2832C6.14716 12.2832 4.57948 11.0323 4.02029 9.35156H1.64453V11.194C2.81463 13.518 5.21948 15.1116 7.99928 15.1116Z"
                    fill="#34A853"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.02079 9.35322C3.87857 8.92655 3.79776 8.47082 3.79776 8.00213C3.79776 7.53344 3.87857 7.07769 4.02079 6.65102V4.80859H1.64504C1.16342 5.76859 0.888672 6.85465 0.888672 8.00213C0.888672 9.1496 1.16342 10.2356 1.64504 11.1956L4.02079 9.35322Z"
                    fill="#FBBC05"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99928 3.71891C9.0433 3.71891 9.9807 4.0777 10.7177 4.78234L12.7573 2.74275C11.5257 1.59527 9.91607 0.890625 7.99928 0.890625C5.21948 0.890625 2.81463 2.48416 1.64453 4.8082L4.02029 6.65063C4.57948 4.96982 6.14716 3.71891 7.99928 3.71891Z"
                    fill="#EA4335"
                />
            </svg>
        ),
        instagramInfo: (
            <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        googleUniColor: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.8267 8.16113C14.8267 7.65689 14.7814 7.17204 14.6974 6.70659H8V9.45726H11.827C11.6622 10.3462 11.1612 11.0993 10.4081 11.6036V13.3878H12.7063C14.0509 12.1498 14.8267 10.3268 14.8267 8.16113Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99977 15.1111C9.9198 15.1111 11.5294 14.4744 12.706 13.3883L10.4079 11.604C9.7711 12.0307 8.95656 12.2828 7.99977 12.2828C6.14765 12.2828 4.57997 11.0319 4.02078 9.35112H1.64502V11.1935C2.81512 13.5175 5.21997 15.1111 7.99977 15.1111Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.02104 9.35093C3.87881 8.92426 3.79801 8.46853 3.79801 7.99984C3.79801 7.53115 3.87881 7.0754 4.02104 6.64873V4.8063H1.64528C1.16366 5.7663 0.888916 6.85236 0.888916 7.99984C0.888916 9.14731 1.16366 10.2333 1.64528 11.1933L4.02104 9.35093Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99977 3.71717C9.04379 3.71717 9.98119 4.07596 10.7181 4.7806L12.7578 2.74101C11.5262 1.59353 9.91656 0.888885 7.99977 0.888885C5.21997 0.888885 2.81512 2.48242 1.64502 4.80646L4.02078 6.64889C4.57997 4.96808 6.14765 3.71717 7.99977 3.71717Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        instagramUniColor: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
            >
                <path
                    d="M5.33397 7.99999C5.33397 6.52811 6.52756 5.3346 8.00032 5.3346C9.47308 5.3346 10.6673 6.52811 10.6673 7.99999C10.6673 9.47187 9.47308 10.6654 8.00032 10.6654C6.52756 10.6654 5.33397 9.47187 5.33397 7.99999ZM3.89225 7.99999C3.89225 10.2675 5.73143 12.1056 8.00032 12.1056C10.2692 12.1056 12.1084 10.2675 12.1084 7.99999C12.1084 5.73246 10.2692 3.89439 8.00032 3.89439C5.73143 3.89439 3.89225 5.73246 3.89225 7.99999ZM11.311 3.7316C11.3109 3.92136 11.3671 4.10689 11.4726 4.26471C11.578 4.42254 11.7279 4.54557 11.9033 4.61826C12.0787 4.69095 12.2717 4.71003 12.4579 4.67308C12.6442 4.63614 12.8153 4.54483 12.9496 4.4107C13.0839 4.27657 13.1754 4.10564 13.2125 3.91954C13.2497 3.73344 13.2307 3.54051 13.1581 3.36517C13.0855 3.18982 12.9625 3.03992 12.8047 2.93443C12.6469 2.82894 12.4613 2.7726 12.2714 2.77252H12.271C12.0165 2.77264 11.7724 2.87371 11.5924 3.05354C11.4124 3.23336 11.3112 3.47724 11.311 3.7316ZM4.76819 14.5082C3.98819 14.4727 3.56424 14.3428 3.2825 14.2331C2.90898 14.0878 2.64247 13.9147 2.36227 13.635C2.08207 13.3554 1.90862 13.0893 1.76385 12.716C1.65402 12.4346 1.52409 12.0107 1.48864 11.2312C1.44985 10.3884 1.44211 10.1352 1.44211 8.00006C1.44211 5.86487 1.45049 5.6124 1.48864 4.76891C1.52416 3.98937 1.65504 3.56638 1.76385 3.28411C1.90926 2.91081 2.08245 2.64446 2.36227 2.36443C2.64209 2.08439 2.90834 1.91105 3.2825 1.76636C3.56411 1.6566 3.98819 1.52675 4.76819 1.49132C5.61149 1.45256 5.86481 1.44482 8.00032 1.44482C10.1358 1.44482 10.3894 1.4532 11.2334 1.49132C12.0134 1.52682 12.4367 1.65763 12.7191 1.76636C13.0926 1.91105 13.3591 2.08478 13.6393 2.36443C13.9195 2.64408 14.0923 2.91081 14.2378 3.28411C14.3476 3.56555 14.4775 3.98937 14.513 4.76891C14.5517 5.6124 14.5595 5.86487 14.5595 8.00006C14.5595 10.1352 14.5517 10.3877 14.513 11.2312C14.4774 12.0107 14.3469 12.4344 14.2378 12.716C14.0923 13.0893 13.9191 13.3556 13.6393 13.635C13.3595 13.9144 13.0926 14.0878 12.7191 14.2331C12.4375 14.3429 12.0134 14.4727 11.2334 14.5082C10.3901 14.5469 10.1368 14.5547 8.00032 14.5547C5.86385 14.5547 5.61123 14.5469 4.76819 14.5082ZM4.70195 0.0528917C3.85027 0.091654 3.26829 0.226618 2.76005 0.424268C2.23369 0.628377 1.7881 0.902208 1.34284 1.3465C0.897572 1.7908 0.624281 2.23682 0.420049 2.76286C0.222281 3.27112 0.0872355 3.85243 0.0484499 4.7036C0.00902436 5.55611 0 5.82866 0 7.99999C0 10.1713 0.00902436 10.4439 0.0484499 11.2964C0.0872355 12.1476 0.222281 12.7289 0.420049 13.2371C0.624281 13.7628 0.897636 14.2094 1.34284 14.6535C1.78804 15.0976 2.23369 15.371 2.76005 15.5757C3.26925 15.7734 3.85027 15.9083 4.70195 15.9471C5.55542 15.9859 5.82769 15.9955 8.00032 15.9955C10.173 15.9955 10.4457 15.9865 11.2987 15.9471C12.1504 15.9083 12.732 15.7734 13.2406 15.5757C13.7666 15.371 14.2125 15.0978 14.6578 14.6535C15.1031 14.2092 15.3758 13.7628 15.5806 13.2371C15.7784 12.7289 15.914 12.1476 15.9522 11.2964C15.991 10.4432 16 10.1713 16 7.99999C16 5.82866 15.991 5.55611 15.9522 4.7036C15.9134 3.85236 15.7784 3.2708 15.5806 2.76286C15.3758 2.23714 15.1024 1.7915 14.6578 1.3465C14.2132 0.901504 13.7666 0.628377 13.2412 0.424268C12.732 0.226618 12.1504 0.0910144 11.2993 0.0528917C10.4463 0.0141294 10.1736 0.00447083 8.00096 0.00447083C5.82833 0.00447083 5.55542 0.0134898 4.70195 0.0528917Z"
                    fill="currentColor"
                />
                <path
                    d="M5.33397 7.99999C5.33397 6.52811 6.52756 5.3346 8.00032 5.3346C9.47308 5.3346 10.6673 6.52811 10.6673 7.99999C10.6673 9.47187 9.47308 10.6654 8.00032 10.6654C6.52756 10.6654 5.33397 9.47187 5.33397 7.99999ZM3.89225 7.99999C3.89225 10.2675 5.73143 12.1056 8.00032 12.1056C10.2692 12.1056 12.1084 10.2675 12.1084 7.99999C12.1084 5.73246 10.2692 3.89439 8.00032 3.89439C5.73143 3.89439 3.89225 5.73246 3.89225 7.99999ZM11.311 3.7316C11.3109 3.92136 11.3671 4.10689 11.4726 4.26471C11.578 4.42254 11.7279 4.54557 11.9033 4.61826C12.0787 4.69095 12.2717 4.71003 12.4579 4.67308C12.6442 4.63614 12.8153 4.54483 12.9496 4.4107C13.0839 4.27657 13.1754 4.10564 13.2125 3.91954C13.2497 3.73344 13.2307 3.54051 13.1581 3.36517C13.0855 3.18982 12.9625 3.03992 12.8047 2.93443C12.6469 2.82894 12.4613 2.7726 12.2714 2.77252H12.271C12.0165 2.77264 11.7724 2.87371 11.5924 3.05354C11.4124 3.23336 11.3112 3.47724 11.311 3.7316ZM4.76819 14.5082C3.98819 14.4727 3.56424 14.3428 3.2825 14.2331C2.90898 14.0878 2.64247 13.9147 2.36227 13.635C2.08207 13.3554 1.90862 13.0893 1.76385 12.716C1.65402 12.4346 1.52409 12.0107 1.48864 11.2312C1.44985 10.3884 1.44211 10.1352 1.44211 8.00006C1.44211 5.86487 1.45049 5.6124 1.48864 4.76891C1.52416 3.98937 1.65504 3.56638 1.76385 3.28411C1.90926 2.91081 2.08245 2.64446 2.36227 2.36443C2.64209 2.08439 2.90834 1.91105 3.2825 1.76636C3.56411 1.6566 3.98819 1.52675 4.76819 1.49132C5.61149 1.45256 5.86481 1.44482 8.00032 1.44482C10.1358 1.44482 10.3894 1.4532 11.2334 1.49132C12.0134 1.52682 12.4367 1.65763 12.7191 1.76636C13.0926 1.91105 13.3591 2.08478 13.6393 2.36443C13.9195 2.64408 14.0923 2.91081 14.2378 3.28411C14.3476 3.56555 14.4775 3.98937 14.513 4.76891C14.5517 5.6124 14.5595 5.86487 14.5595 8.00006C14.5595 10.1352 14.5517 10.3877 14.513 11.2312C14.4774 12.0107 14.3469 12.4344 14.2378 12.716C14.0923 13.0893 13.9191 13.3556 13.6393 13.635C13.3595 13.9144 13.0926 14.0878 12.7191 14.2331C12.4375 14.3429 12.0134 14.4727 11.2334 14.5082C10.3901 14.5469 10.1368 14.5547 8.00032 14.5547C5.86385 14.5547 5.61123 14.5469 4.76819 14.5082ZM4.70195 0.0528917C3.85027 0.091654 3.26829 0.226618 2.76005 0.424268C2.23369 0.628377 1.7881 0.902208 1.34284 1.3465C0.897572 1.7908 0.624281 2.23682 0.420049 2.76286C0.222281 3.27112 0.0872355 3.85243 0.0484499 4.7036C0.00902436 5.55611 0 5.82866 0 7.99999C0 10.1713 0.00902436 10.4439 0.0484499 11.2964C0.0872355 12.1476 0.222281 12.7289 0.420049 13.2371C0.624281 13.7628 0.897636 14.2094 1.34284 14.6535C1.78804 15.0976 2.23369 15.371 2.76005 15.5757C3.26925 15.7734 3.85027 15.9083 4.70195 15.9471C5.55542 15.9859 5.82769 15.9955 8.00032 15.9955C10.173 15.9955 10.4457 15.9865 11.2987 15.9471C12.1504 15.9083 12.732 15.7734 13.2406 15.5757C13.7666 15.371 14.2125 15.0978 14.6578 14.6535C15.1031 14.2092 15.3758 13.7628 15.5806 13.2371C15.7784 12.7289 15.914 12.1476 15.9522 11.2964C15.991 10.4432 16 10.1713 16 7.99999C16 5.82866 15.991 5.55611 15.9522 4.7036C15.9134 3.85236 15.7784 3.2708 15.5806 2.76286C15.3758 2.23714 15.1024 1.7915 14.6578 1.3465C14.2132 0.901504 13.7666 0.628377 13.2412 0.424268C12.732 0.226618 12.1504 0.0910144 11.2993 0.0528917C10.4463 0.0141294 10.1736 0.00447083 8.00096 0.00447083C5.82833 0.00447083 5.55542 0.0134898 4.70195 0.0528917Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        facebookUniColor: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
            >
                <path
                    d="M8.74322 8.99943L9.19915 6.10514H6.39058V4.22386C6.39058 3.43245 6.78269 2.65913 8.03652 2.65913H9.33138V0.19446C8.57731 0.0743206 7.81536 0.00932539 7.05169 0C4.74009 0 3.23094 1.38835 3.23094 3.89825V6.10514H0.668579V8.99943H3.23094V16H6.39058V8.99943H8.74322Z"
                    fill="currentColor"
                />
            </SvgIcon>
        ),
        minus: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M5 12H19"
                    stroke="#5B7DD8"
                    strokeOpacity="0.16"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        circleQRCode: (
            <SvgIcon width="116" height="116" viewBox="0 0 116 116" fill="none">
                <g filter="url(#filter0_dd_2182_12891)">
                    <rect x="18" y="17" width="80" height="80" rx="40" fill="#00041F" shapeRendering="crispEdges" />
                    <path
                        d="M47 46H47.02M69 46H69.02M47 68H47.02M60 59H60.02M69 68H69.02M68 75H76V67M62 66V75M76 61H67M65.2 53H72.8C73.9201 53 74.4802 53 74.908 52.782C75.2843 52.5903 75.5903 52.2843 75.782 51.908C76 51.4802 76 50.9201 76 49.8V42.2C76 41.0799 76 40.5198 75.782 40.092C75.5903 39.7157 75.2843 39.4097 74.908 39.218C74.4802 39 73.9201 39 72.8 39H65.2C64.0799 39 63.5198 39 63.092 39.218C62.7157 39.4097 62.4097 39.7157 62.218 40.092C62 40.5198 62 41.0799 62 42.2V49.8C62 50.9201 62 51.4802 62.218 51.908C62.4097 52.2843 62.7157 52.5903 63.092 52.782C63.5198 53 64.0799 53 65.2 53ZM43.2 53H50.8C51.9201 53 52.4802 53 52.908 52.782C53.2843 52.5903 53.5903 52.2843 53.782 51.908C54 51.4802 54 50.9201 54 49.8V42.2C54 41.0799 54 40.5198 53.782 40.092C53.5903 39.7157 53.2843 39.4097 52.908 39.218C52.4802 39 51.9201 39 50.8 39H43.2C42.0799 39 41.5198 39 41.092 39.218C40.7157 39.4097 40.4097 39.7157 40.218 40.092C40 40.5198 40 41.0799 40 42.2V49.8C40 50.9201 40 51.4802 40.218 51.908C40.4097 52.2843 40.7157 52.5903 41.092 52.782C41.5198 53 42.0799 53 43.2 53ZM43.2 75H50.8C51.9201 75 52.4802 75 52.908 74.782C53.2843 74.5903 53.5903 74.2843 53.782 73.908C54 73.4802 54 72.9201 54 71.8V64.2C54 63.0799 54 62.5198 53.782 62.092C53.5903 61.7157 53.2843 61.4097 52.908 61.218C52.4802 61 51.9201 61 50.8 61H43.2C42.0799 61 41.5198 61 41.092 61.218C40.7157 61.4097 40.4097 61.7157 40.218 62.092C40 62.5198 40 63.0799 40 64.2V71.8C40 72.9201 40 73.4802 40.218 73.908C40.4097 74.2843 40.7157 74.5903 41.092 74.782C41.5198 75 42.0799 75 43.2 75Z"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_dd_2182_12891"
                        x="0"
                        y="0"
                        width="116"
                        height="116"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="6" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0.0156863 0 0 0 0 0.121569 0 0 0 0.16 0"
                        />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2182_12891" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="9" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0.0156863 0 0 0 0 0.121569 0 0 0 0.16 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="effect1_dropShadow_2182_12891"
                            result="effect2_dropShadow_2182_12891"
                        />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2182_12891" result="shape" />
                    </filter>
                </defs>
            </SvgIcon>
        ),
        qr: (
            <SvgIcon
                sx={{ fill: "none", ...sx }}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.41667 4.41667H4.425M13.5833 4.41667H13.5917M4.41667 13.5833H4.425M9.83333 9.83333H9.84167M13.5833 13.5833H13.5917M13.1667 16.5H16.5V13.1667M10.6667 12.75V16.5M16.5 10.6667H12.75M12 7.33333H15.1667C15.6334 7.33333 15.8667 7.33333 16.045 7.24251C16.2018 7.16261 16.3293 7.03513 16.4092 6.87833C16.5 6.70007 16.5 6.46671 16.5 6V2.83333C16.5 2.36662 16.5 2.13327 16.4092 1.95501C16.3293 1.79821 16.2018 1.67072 16.045 1.59083C15.8667 1.5 15.6334 1.5 15.1667 1.5H12C11.5333 1.5 11.2999 1.5 11.1217 1.59083C10.9649 1.67072 10.8374 1.79821 10.7575 1.95501C10.6667 2.13327 10.6667 2.36662 10.6667 2.83333V6C10.6667 6.46671 10.6667 6.70007 10.7575 6.87833C10.8374 7.03513 10.9649 7.16261 11.1217 7.24251C11.2999 7.33333 11.5333 7.33333 12 7.33333ZM2.83333 7.33333H6C6.46671 7.33333 6.70007 7.33333 6.87833 7.24251C7.03513 7.16261 7.16261 7.03513 7.24251 6.87833C7.33333 6.70007 7.33333 6.46671 7.33333 6V2.83333C7.33333 2.36662 7.33333 2.13327 7.24251 1.95501C7.16261 1.79821 7.03513 1.67072 6.87833 1.59083C6.70007 1.5 6.46671 1.5 6 1.5H2.83333C2.36662 1.5 2.13327 1.5 1.95501 1.59083C1.79821 1.67072 1.67072 1.79821 1.59083 1.95501C1.5 2.13327 1.5 2.36662 1.5 2.83333V6C1.5 6.46671 1.5 6.70007 1.59083 6.87833C1.67072 7.03513 1.79821 7.16261 1.95501 7.24251C2.13327 7.33333 2.36662 7.33333 2.83333 7.33333ZM2.83333 16.5H6C6.46671 16.5 6.70007 16.5 6.87833 16.4092C7.03513 16.3293 7.16261 16.2018 7.24251 16.045C7.33333 15.8667 7.33333 15.6334 7.33333 15.1667V12C7.33333 11.5333 7.33333 11.2999 7.24251 11.1217C7.16261 10.9649 7.03513 10.8374 6.87833 10.7575C6.70007 10.6667 6.46671 10.6667 6 10.6667H2.83333C2.36662 10.6667 2.13327 10.6667 1.95501 10.7575C1.79821 10.8374 1.67072 10.9649 1.59083 11.1217C1.5 11.2999 1.5 11.5333 1.5 12V15.1667C1.5 15.6334 1.5 15.8667 1.59083 16.045C1.67072 16.2018 1.79821 16.3293 1.95501 16.4092C2.13327 16.5 2.36662 16.5 2.83333 16.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </SvgIcon>
        ),
        qr2: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 6.5H6.51M17.5 6.5H17.51M6.5 17.5H6.51M13 13H13.01M17.5 17.5H17.51M17 21H21V17M14 16.5V21M21 14H16.5M15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10ZM4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z"
                    stroke="#68738D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    }
    return <>{icons[name]}</>
}

export default Icon
